var On = Object.create;
var He = Object.defineProperty;
var Nn = Object.getOwnPropertyDescriptor;
var dt = (t, e) => (e = Symbol[t]) ? e : Symbol.for("Symbol." + t), _e = (t) => {
  throw TypeError(t);
};
var pt = (t, e, n) => e in t ? He(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var ct = (t, e) => He(t, "name", { value: e, configurable: !0 });
var mt = (t) => [, , , On((t == null ? void 0 : t[dt("metadata")]) ?? null)], _t = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], me = (t) => t !== void 0 && typeof t != "function" ? _e("Function expected") : t, Un = (t, e, n, r, i) => ({ kind: _t[t], name: e, metadata: r, addInitializer: (o) => n._ ? _e("Already initialized") : i.push(me(o || null)) }), xe = (t, e) => pt(e, dt("metadata"), t[3]), gt = (t, e, n, r) => {
  for (var i = 0, o = t[e >> 1], s = o && o.length; i < s; i++) e & 1 ? o[i].call(n) : r = o[i].call(n, r);
  return r;
}, ht = (t, e, n, r, i, o) => {
  var s, l, a, c, f, u = e & 7, m = !!(e & 8), h = !!(e & 16), y = u > 3 ? t.length + 1 : u ? m ? 1 : 2 : 0, T = _t[u + 5], w = u > 3 && (t[y - 1] = []), O = t[y] || (t[y] = []), C = u && (!h && !m && (i = i.prototype), u < 5 && (u > 3 || !h) && Nn(u < 4 ? i : { get [n]() {
    return ut(this, o);
  }, set [n](P) {
    return ft(this, o, P);
  } }, n));
  u ? h && u < 4 && ct(o, (u > 2 ? "set " : u > 1 ? "get " : "") + n) : ct(i, n);
  for (var E = r.length - 1; E >= 0; E--)
    c = Un(u, n, a = {}, t[3], O), u && (c.static = m, c.private = h, f = c.access = { has: h ? (P) => Rn(i, P) : (P) => n in P }, u ^ 3 && (f.get = h ? (P) => (u ^ 1 ? ut : Ln)(P, i, u ^ 4 ? o : C.get) : (P) => P[n]), u > 2 && (f.set = h ? (P, B) => ft(P, i, B, u ^ 4 ? o : C.set) : (P, B) => P[n] = B)), l = (0, r[E])(u ? u < 4 ? h ? o : C[T] : u > 4 ? void 0 : { get: C.get, set: C.set } : i, c), a._ = 1, u ^ 4 || l === void 0 ? me(l) && (u > 4 ? w.unshift(l) : u ? h ? o = l : C[T] = l : i = l) : typeof l != "object" || l === null ? _e("Object expected") : (me(s = l.get) && (C.get = s), me(s = l.set) && (C.set = s), me(s = l.init) && w.unshift(s));
  return u || xe(t, i), C && He(i, n, C), h ? u ^ 4 ? o : C : i;
}, N = (t, e, n) => pt(t, typeof e != "symbol" ? e + "" : e, n), qe = (t, e, n) => e.has(t) || _e("Cannot " + n), Rn = (t, e) => Object(e) !== e ? _e('Cannot use the "in" operator on this value') : t.has(e), ut = (t, e, n) => (qe(t, e, "read from private field"), n ? n.call(t) : e.get(t));
var ft = (t, e, n, r) => (qe(t, e, "write to private field"), r ? r.call(t, n) : e.set(t, n), n), Ln = (t, e, n) => (qe(t, e, "access private method"), n);
function A() {
}
function Sn(t, e) {
  for (const n in e) t[n] = e[n];
  return (
    /** @type {T & S} */
    t
  );
}
function Wt(t) {
  return t();
}
function bt() {
  return /* @__PURE__ */ Object.create(null);
}
function ve(t) {
  t.forEach(Wt);
}
function fe(t) {
  return typeof t == "function";
}
function S(t, e) {
  return t != t ? e == e : t !== e || t && typeof t == "object" || typeof t == "function";
}
let Ne;
function Ee(t, e) {
  return t === e ? !0 : (Ne || (Ne = document.createElement("a")), Ne.href = e, t === Ne.href);
}
function wt(t) {
  return t.split(",").map((e) => e.trim().split(" ").filter(Boolean));
}
function Mn(t, e) {
  const n = wt(t.srcset), r = wt(e || "");
  return r.length === n.length && r.every(
    ([i, o], s) => o === n[s][1] && // We need to test both ways because Vite will create an a full URL with
    // `new URL(asset, import.meta.url).href` for the client when `base: './'`, and the
    // relative URLs inside srcset are not automatically resolved to absolute URLs by
    // browsers (in contrast to img.src). This means both SSR and DOM code could
    // contain relative or absolute URLs.
    (Ee(n[s][0], i) || Ee(i, n[s][0]))
  );
}
function Dn(t) {
  return Object.keys(t).length === 0;
}
function q(t, e, n, r) {
  if (t) {
    const i = Kt(t, e, n, r);
    return t[0](i);
  }
}
function Kt(t, e, n, r) {
  return t[1] && r ? Sn(n.ctx.slice(), t[1](r(e))) : n.ctx;
}
function G(t, e, n, r) {
  if (t[2] && r) {
    const i = t[2](r(n));
    if (e.dirty === void 0)
      return i;
    if (typeof i == "object") {
      const o = [], s = Math.max(e.dirty.length, i.length);
      for (let l = 0; l < s; l += 1)
        o[l] = e.dirty[l] | i[l];
      return o;
    }
    return e.dirty | i;
  }
  return e.dirty;
}
function V(t, e, n, r, i, o) {
  if (i) {
    const s = Kt(e, n, r, o);
    t.p(s, i);
  }
}
function Y(t) {
  if (t.ctx.length > 32) {
    const e = [], n = t.ctx.length / 32;
    for (let r = 0; r < n; r++)
      e[r] = -1;
    return e;
  }
  return -1;
}
function We(t) {
  return t ?? "";
}
function L(t, e) {
  t.appendChild(e);
}
function F(t, e, n) {
  const r = Bn(t);
  if (!r.getElementById(e)) {
    const i = I("style");
    i.id = e, i.textContent = n, Cn(r, i);
  }
}
function Bn(t) {
  if (!t) return document;
  const e = t.getRootNode ? t.getRootNode() : t.ownerDocument;
  return e && /** @type {ShadowRoot} */
  e.host ? (
    /** @type {ShadowRoot} */
    e
  ) : t.ownerDocument;
}
function Cn(t, e) {
  return L(
    /** @type {Document} */
    t.head || t,
    e
  ), e.sheet;
}
function g(t, e, n) {
  t.insertBefore(e, n || null);
}
function _(t) {
  t.parentNode && t.parentNode.removeChild(t);
}
function I(t) {
  return document.createElement(t);
}
function H(t) {
  return document.createTextNode(t);
}
function U() {
  return H(" ");
}
function ee() {
  return H("");
}
function $e(t, e, n, r) {
  return t.addEventListener(e, n, r), () => t.removeEventListener(e, n, r);
}
function Qt(t) {
  return function(e) {
    return e.preventDefault(), t.call(this, e);
  };
}
function b(t, e, n) {
  n == null ? t.removeAttribute(e) : t.getAttribute(e) !== n && t.setAttribute(e, n);
}
const Fn = ["width", "height"];
function jn(t, e) {
  const n = Object.getOwnPropertyDescriptors(t.__proto__);
  for (const r in e)
    e[r] == null ? t.removeAttribute(r) : r === "style" ? t.style.cssText = e[r] : r === "__value" ? t.value = t[r] = e[r] : n[r] && n[r].set && Fn.indexOf(r) === -1 ? t[r] = e[r] : b(t, r, e[r]);
}
function Hn(t, e) {
  Object.keys(e).forEach((n) => {
    xn(t, n, e[n]);
  });
}
function xn(t, e, n) {
  const r = e.toLowerCase();
  r in t ? t[r] = typeof t[r] == "boolean" && n === "" ? !0 : n : e in t ? t[e] = typeof t[e] == "boolean" && n === "" ? !0 : n : b(t, e, n);
}
function qn(t) {
  return /-/.test(t) ? Hn : jn;
}
function Gn(t) {
  return Array.from(t.childNodes);
}
function te(t, e) {
  e = "" + e, t.data !== e && (t.data = /** @type {string} */
  e);
}
function yt(t, e) {
  t.value = e ?? "";
}
function ne(t, e, n, r) {
  n == null ? t.style.removeProperty(e) : t.style.setProperty(e, n, "");
}
function Vn(t, e, { bubbles: n = !1, cancelable: r = !1 } = {}) {
  return new CustomEvent(t, { detail: e, bubbles: n, cancelable: r });
}
let Ie;
function we(t) {
  Ie = t;
}
function ke() {
  if (!Ie) throw new Error("Function called outside component initialization");
  return Ie;
}
function Yn(t) {
  ke().$$.before_update.push(t);
}
function Fe(t) {
  ke().$$.on_mount.push(t);
}
function zn() {
  const t = ke();
  return (e, n, { cancelable: r = !1 } = {}) => {
    const i = t.$$.callbacks[e];
    if (i) {
      const o = Vn(
        /** @type {string} */
        e,
        n,
        { cancelable: r }
      );
      return i.slice().forEach((s) => {
        s.call(t, o);
      }), !o.defaultPrevented;
    }
    return !0;
  };
}
function Wn(t, e) {
  return ke().$$.context.set(t, e), e;
}
function Kn(t) {
  return ke().$$.context.get(t);
}
function Xt(t, e) {
  const n = t.$$.callbacks[e.type];
  n && n.slice().forEach((r) => r.call(this, e));
}
const ae = [], De = [];
let ue = [];
const Ke = [], Qn = /* @__PURE__ */ Promise.resolve();
let Qe = !1;
function Xn() {
  Qe || (Qe = !0, Qn.then(Zt));
}
function Xe(t) {
  ue.push(t);
}
function Zn(t) {
  Ke.push(t);
}
const Ge = /* @__PURE__ */ new Set();
let se = 0;
function Zt() {
  if (se !== 0)
    return;
  const t = Ie;
  do {
    try {
      for (; se < ae.length; ) {
        const e = ae[se];
        se++, we(e), Jn(e.$$);
      }
    } catch (e) {
      throw ae.length = 0, se = 0, e;
    }
    for (we(null), ae.length = 0, se = 0; De.length; ) De.pop()();
    for (let e = 0; e < ue.length; e += 1) {
      const n = ue[e];
      Ge.has(n) || (Ge.add(n), n());
    }
    ue.length = 0;
  } while (ae.length);
  for (; Ke.length; )
    Ke.pop()();
  Qe = !1, Ge.clear(), we(t);
}
function Jn(t) {
  if (t.fragment !== null) {
    t.update(), ve(t.before_update);
    const e = t.dirty;
    t.dirty = [-1], t.fragment && t.fragment.p(t.ctx, e), t.after_update.forEach(Xe);
  }
}
function er(t) {
  const e = [], n = [];
  ue.forEach((r) => t.indexOf(r) === -1 ? e.push(r) : n.push(r)), n.forEach((r) => r()), ue = e;
}
const Se = /* @__PURE__ */ new Set();
let oe;
function z() {
  oe = {
    r: 0,
    c: [],
    p: oe
    // parent group
  };
}
function W() {
  oe.r || ve(oe.c), oe = oe.p;
}
function d(t, e) {
  t && t.i && (Se.delete(t), t.i(e));
}
function p(t, e, n, r) {
  if (t && t.o) {
    if (Se.has(t)) return;
    Se.add(t), oe.c.push(() => {
      Se.delete(t), r && (n && t.d(1), r());
    }), t.o(e);
  } else r && r();
}
function tr(t, e, n) {
  const r = t.$$.props[e];
  r !== void 0 && (t.$$.bound[r] = n, n(t.$$.ctx[r]));
}
function k(t) {
  t && t.c();
}
function v(t, e, n) {
  const { fragment: r, after_update: i } = t.$$;
  r && r.m(e, n), Xe(() => {
    const o = t.$$.on_mount.map(Wt).filter(fe);
    t.$$.on_destroy ? t.$$.on_destroy.push(...o) : ve(o), t.$$.on_mount = [];
  }), i.forEach(Xe);
}
function $(t, e) {
  const n = t.$$;
  n.fragment !== null && (er(n.after_update), ve(n.on_destroy), n.fragment && n.fragment.d(e), n.on_destroy = n.fragment = null, n.ctx = []);
}
function nr(t, e) {
  t.$$.dirty[0] === -1 && (ae.push(t), Xn(), t.$$.dirty.fill(0)), t.$$.dirty[e / 31 | 0] |= 1 << e % 31;
}
function M(t, e, n, r, i, o, s = null, l = [-1]) {
  const a = Ie;
  we(t);
  const c = t.$$ = {
    fragment: null,
    ctx: [],
    // state
    props: o,
    update: A,
    not_equal: i,
    bound: bt(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(e.context || (a ? a.$$.context : [])),
    // everything else
    callbacks: bt(),
    dirty: l,
    skip_bound: !1,
    root: e.target || a.$$.root
  };
  s && s(c.root);
  let f = !1;
  if (c.ctx = n ? n(t, e.props || {}, (u, m, ...h) => {
    const y = h.length ? h[0] : m;
    return c.ctx && i(c.ctx[u], c.ctx[u] = y) && (!c.skip_bound && c.bound[u] && c.bound[u](y), f && nr(t, u)), m;
  }) : [], c.update(), f = !0, ve(c.before_update), c.fragment = r ? r(c.ctx) : !1, e.target) {
    if (e.hydrate) {
      const u = Gn(e.target);
      c.fragment && c.fragment.l(u), u.forEach(_);
    } else
      c.fragment && c.fragment.c();
    e.intro && d(t.$$.fragment), v(t, e.target, e.anchor), Zt();
  }
  we(a);
}
class D {
  constructor() {
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    N(this, "$$");
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    N(this, "$$set");
  }
  /** @returns {void} */
  $destroy() {
    $(this, 1), this.$destroy = A;
  }
  /**
   * @template {Extract<keyof Events, string>} K
   * @param {K} type
   * @param {((e: Events[K]) => void) | null | undefined} callback
   * @returns {() => void}
   */
  $on(e, n) {
    if (!fe(n))
      return A;
    const r = this.$$.callbacks[e] || (this.$$.callbacks[e] = []);
    return r.push(n), () => {
      const i = r.indexOf(n);
      i !== -1 && r.splice(i, 1);
    };
  }
  /**
   * @param {Partial<Props>} props
   * @returns {void}
   */
  $set(e) {
    this.$$set && !Dn(e) && (this.$$.skip_bound = !0, this.$$set(e), this.$$.skip_bound = !1);
  }
}
const rr = "4";
typeof window < "u" && (window.__svelte || (window.__svelte = { v: /* @__PURE__ */ new Set() })).v.add(rr);
function ir(t) {
  F(t, "svelte-1bzqb13", ".rcb-modal-section.svelte-1bzqb13{padding:8px 0px;display:flex}section.rcb-modal-section.svelte-1bzqb13{flex-grow:1}.rcb-modal-section.svelte-1bzqb13:last-of-type{padding:0}");
}
function Ve(t) {
  let e, n;
  const r = (
    /*#slots*/
    t[2].default
  ), i = q(
    r,
    t,
    /*$$scope*/
    t[1],
    null
  );
  return {
    c() {
      e = I(
        /*as*/
        t[0]
      ), i && i.c(), qn(
        /*as*/
        t[0]
      )(e, {
        class: We("rcb-modal-section") + " svelte-1bzqb13"
      });
    },
    m(o, s) {
      g(o, e, s), i && i.m(e, null), n = !0;
    },
    p(o, s) {
      i && i.p && (!n || s & /*$$scope*/
      2) && V(
        i,
        r,
        o,
        /*$$scope*/
        o[1],
        n ? G(
          r,
          /*$$scope*/
          o[1],
          s,
          null
        ) : Y(
          /*$$scope*/
          o[1]
        ),
        null
      );
    },
    i(o) {
      n || (d(i, o), n = !0);
    },
    o(o) {
      p(i, o), n = !1;
    },
    d(o) {
      o && _(e), i && i.d(o);
    }
  };
}
function or(t) {
  let e = (
    /*as*/
    t[0]
  ), n, r, i = (
    /*as*/
    t[0] && Ve(t)
  );
  return {
    c() {
      i && i.c(), n = ee();
    },
    m(o, s) {
      i && i.m(o, s), g(o, n, s), r = !0;
    },
    p(o, [s]) {
      /*as*/
      o[0] ? e ? S(
        e,
        /*as*/
        o[0]
      ) ? (i.d(1), i = Ve(o), e = /*as*/
      o[0], i.c(), i.m(n.parentNode, n)) : i.p(o, s) : (i = Ve(o), e = /*as*/
      o[0], i.c(), i.m(n.parentNode, n)) : e && (i.d(1), i = null, e = /*as*/
      o[0]);
    },
    i(o) {
      r || (d(i, o), r = !0);
    },
    o(o) {
      p(i, o), r = !1;
    },
    d(o) {
      o && _(n), i && i.d(o);
    }
  };
}
function sr(t, e, n) {
  let { $$slots: r = {}, $$scope: i } = e, { as: o = "section" } = e;
  return t.$$set = (s) => {
    "as" in s && n(0, o = s.as), "$$scope" in s && n(1, i = s.$$scope);
  }, [o, i, r];
}
class de extends D {
  constructor(e) {
    super(), M(this, e, sr, or, S, { as: 0 }, ir);
  }
}
var J = /* @__PURE__ */ ((t) => (t[t.Silent = 0] = "Silent", t[t.Error = 1] = "Error", t[t.Warn = 2] = "Warn", t[t.Info = 3] = "Info", t[t.Debug = 4] = "Debug", t[t.Verbose = 5] = "Verbose", t))(J || {});
class j {
  static setLogLevel(e) {
    this.logLevel = e;
  }
  static log(e, n = this.logLevel) {
    const r = `[Purchases] ${e}`;
    if (!(this.logLevel < n || n === J.Silent))
      switch (n) {
        case J.Error:
          console.error(r);
          break;
        case J.Warn:
          console.warn(r);
          break;
        case J.Info:
          console.info(r);
          break;
        case J.Debug:
          console.debug(r);
          break;
        case J.Verbose:
          console.debug(r);
          break;
      }
  }
  static errorLog(e) {
    this.log(e, J.Error);
  }
  static warnLog(e) {
    this.log(e, J.Warn);
  }
  static infoLog(e) {
    this.log(e, J.Info);
  }
  static debugLog(e) {
    this.log(e, J.Debug);
  }
  static verboseLog(e) {
    this.log(e, J.Verbose);
  }
}
N(j, "logLevel", J.Silent);
var re = /* @__PURE__ */ ((t) => (t.Year = "year", t.Month = "month", t.Week = "week", t.Day = "day", t))(re || {});
function et(t) {
  const e = t.match(/^PT?([0-9]+)([MDYW])$/);
  if (!e || e.length < 3)
    return j.errorLog(`Invalid ISO 8601 duration format: ${t}`), null;
  const n = parseInt(e[1]);
  switch (e[2]) {
    case "Y":
      return {
        number: n,
        unit: "year"
        /* Year */
      };
    case "M":
      return {
        number: n,
        unit: "month"
        /* Month */
      };
    case "W":
      return {
        number: n,
        unit: "week"
        /* Week */
      };
    case "D":
      return {
        number: n,
        unit: "day"
        /* Day */
      };
    default:
      return j.errorLog(`Invalid ISO 8601 unit duration format: ${t}`), null;
  }
}
const lr = (t, e, n) => {
  const r = t / 1e6;
  return new Intl.NumberFormat(n, {
    style: "currency",
    currency: e
  }).format(r);
}, ar = (t) => {
  const e = t.number;
  if (e === 1)
    switch (t.unit) {
      case re.Year:
        return "yearly";
      case re.Month:
        return "monthly";
      case re.Week:
        return "weekly";
      case re.Day:
        return "daily";
    }
  else
    return `every ${e} ${t.unit}s`;
}, cr = (t) => {
  const e = t.number;
  if (e === 1)
    switch (t.unit) {
      case re.Year:
        return "1 year";
      case re.Month:
        return "1 month";
      case re.Week:
        return "1 week";
      case re.Day:
        return "1 day";
    }
  else
    return `${e} ${t.unit}s`;
}, Et = (t) => {
  const e = et(t);
  return e ? ar(e) : "unknown";
}, ur = (t) => {
  const e = et(t);
  return e ? cr(e) : "unknown";
};
function fr(t) {
  return t != null;
}
var dr = /* @__PURE__ */ ((t) => (t.Unknown = "unknown", t.Custom = "custom", t.Lifetime = "$rc_lifetime", t.Annual = "$rc_annual", t.SixMonth = "$rc_six_month", t.ThreeMonth = "$rc_three_month", t.TwoMonth = "$rc_two_month", t.Monthly = "$rc_monthly", t.Weekly = "$rc_weekly", t))(dr || {}), Pe = /* @__PURE__ */ ((t) => (t.Subscription = "subscription", t.Consumable = "consumable", t.NonConsumable = "non_consumable", t))(Pe || {});
const Jt = (t) => ({
  amount: t.amount_micros / 1e4,
  amountMicros: t.amount_micros,
  currency: t.currency,
  formattedPrice: lr(t.amount_micros, t.currency)
}), It = (t) => {
  const e = t.period_duration;
  return {
    periodDuration: e,
    period: e ? et(e) : null,
    cycleCount: t.cycle_count,
    price: t.price ? Jt(t.price) : null
  };
}, pr = (t) => t.base == null ? (j.debugLog("Missing base phase for subscription option. Ignoring."), null) : {
  id: t.id,
  priceId: t.price_id,
  base: It(t.base),
  trial: t.trial ? It(t.trial) : null
}, mr = (t) => t.base_price == null ? (j.debugLog(
  "Missing base price for non-subscription option. Ignoring."
), null) : {
  id: t.id,
  priceId: t.price_id,
  basePrice: Jt(t.base_price)
}, _r = (t, e) => {
  const n = t.product_type;
  return n === "subscription" ? hr(
    t,
    e,
    n
  ) : gr(
    t,
    e,
    n
  );
}, gr = (t, e, n) => {
  const r = {};
  if (Object.entries(t.purchase_options).forEach(
    ([s, l]) => {
      const a = mr(
        l
      );
      a != null && (r[s] = a);
    }
  ), Object.keys(r).length === 0)
    return j.debugLog(
      `Product ${t.identifier} has no purchase options. Ignoring.`
    ), null;
  const i = t.default_purchase_option_id, o = i && i in t.purchase_options ? r[i] : null;
  return o == null ? (j.debugLog(
    `Product ${t.identifier} has no default purchase option. Ignoring.`
  ), null) : {
    identifier: t.identifier,
    displayName: t.title,
    title: t.title,
    description: t.description,
    productType: n,
    currentPrice: o.basePrice,
    normalPeriodDuration: null,
    presentedOfferingIdentifier: e.offeringIdentifier,
    presentedOfferingContext: e,
    defaultPurchaseOption: o,
    defaultSubscriptionOption: null,
    subscriptionOptions: {},
    defaultNonSubscriptionOption: o
  };
}, hr = (t, e, n) => {
  const r = {};
  if (Object.entries(t.purchase_options).forEach(
    ([l, a]) => {
      const c = pr(a);
      c != null && (r[l] = c);
    }
  ), Object.keys(r).length === 0)
    return j.debugLog(
      `Product ${t.identifier} has no subscription options. Ignoring.`
    ), null;
  const i = t.default_purchase_option_id, o = i && i in r ? r[i] : null;
  if (o == null)
    return j.debugLog(
      `Product ${t.identifier} has no default subscription option. Ignoring.`
    ), null;
  const s = o.base.price;
  return s == null ? (j.debugLog(
    `Product ${t.identifier} default option has no base price. Ignoring.`
  ), null) : {
    identifier: t.identifier,
    displayName: t.title,
    title: t.title,
    description: t.description,
    productType: n,
    currentPrice: s,
    normalPeriodDuration: o.base.periodDuration,
    presentedOfferingIdentifier: e.offeringIdentifier,
    presentedOfferingContext: e,
    defaultPurchaseOption: o,
    defaultSubscriptionOption: o,
    subscriptionOptions: r,
    defaultNonSubscriptionOption: null
  };
}, br = (t, e, n) => {
  const r = n[e.platform_product_identifier];
  if (r === void 0) return null;
  const i = _r(r, t);
  return i === null ? null : {
    identifier: e.identifier,
    rcBillingProduct: i,
    packageType: yr(e.identifier)
  };
}, wr = (t, e, n, r) => {
  const i = {
    offeringIdentifier: e.identifier,
    targetingContext: t && r ? {
      ruleId: r.rule_id,
      revision: r.revision
    } : null,
    placementIdentifier: null
  }, o = e.packages.map(
    (l) => br(i, l, n)
  ).filter(fr), s = {};
  for (const l of o)
    l != null && (s[l.identifier] = l);
  return o.length == 0 ? null : {
    identifier: e.identifier,
    serverDescription: e.description,
    metadata: e.metadata,
    packagesById: s,
    availablePackages: o,
    lifetime: s.$rc_lifetime ?? null,
    annual: s.$rc_annual ?? null,
    sixMonth: s.$rc_six_month ?? null,
    threeMonth: s.$rc_three_month ?? null,
    twoMonth: s.$rc_two_month ?? null,
    monthly: s.$rc_monthly ?? null,
    weekly: s.$rc_weekly ?? null
  };
};
function yr(t) {
  switch (t) {
    case "$rc_lifetime":
      return "$rc_lifetime";
    case "$rc_annual":
      return "$rc_annual";
    case "$rc_six_month":
      return "$rc_six_month";
    case "$rc_three_month":
      return "$rc_three_month";
    case "$rc_two_month":
      return "$rc_two_month";
    case "$rc_monthly":
      return "$rc_monthly";
    case "$rc_weekly":
      return "$rc_weekly";
    default:
      return t.startsWith("$rc_") ? "unknown" : "custom";
  }
}
function Er(t) {
  F(t, "svelte-1mdrqnh", ".rcb-pricing-info.svelte-1mdrqnh{display:flex;flex-direction:column;margin-top:102px;font-weight:500}.rcb-product-price.svelte-1mdrqnh{color:var(--rc-color-grey-text-dark);font-size:24px;margin:12px 0px}.rcb-product-description.svelte-1mdrqnh{color:var(--rc-color-grey-text-dark);margin:0 0 12px 0}.rcb-product-price-after-trial.svelte-1mdrqnh{margin-bottom:12px}.rcb-product-details.svelte-1mdrqnh{color:var(--rc-color-grey-text-light);list-style-type:disc;list-style-position:inside;margin:0px;padding:0px}@media screen and (max-width: 960px){.rcb-pricing-info.svelte-1mdrqnh{margin-top:48px}}");
}
function Ir(t) {
  var w, O, C;
  let e, n, r, i, o, s, l, a, c, f, u = (
    /*subscriptionTrial*/
    ((w = t[3]) == null ? void 0 : w.periodDuration) && vr(t)
  ), m = !/*subscriptionTrial*/
  ((O = t[3]) != null && O.periodDuration) && /*subscriptionBasePrice*/
  t[4] && $r(t), h = (
    /*subscriptionTrial*/
    t[3] && /*subscriptionBasePrice*/
    t[4] && kr(t)
  ), y = (
    /*brandingAppearance*/
    ((C = t[1]) == null ? void 0 : C.show_product_description) && /*productDetails*/
    t[0].description && vt(t)
  ), T = (
    /*productDetails*/
    t[0].normalPeriodDuration && $t(t)
  );
  return {
    c() {
      e = I("span"), u && u.c(), n = U(), m && m.c(), r = U(), h && h.c(), i = U(), y && y.c(), o = U(), s = I("ul"), T && T.c(), l = U(), a = I("li"), a.textContent = "Continues until canceled", c = U(), f = I("li"), f.textContent = "Cancel anytime", b(e, "class", "rcb-product-price svelte-1mdrqnh"), b(s, "class", "rcb-product-details svelte-1mdrqnh");
    },
    m(E, P) {
      g(E, e, P), u && u.m(e, null), L(e, n), m && m.m(e, null), g(E, r, P), h && h.m(E, P), g(E, i, P), y && y.m(E, P), g(E, o, P), g(E, s, P), T && T.m(s, null), L(s, l), L(s, a), L(s, c), L(s, f);
    },
    p(E, P) {
      var B, Ae, Oe;
      /*subscriptionTrial*/
      (B = E[3]) != null && B.periodDuration && u.p(E, P), !/*subscriptionTrial*/
      ((Ae = E[3]) != null && Ae.periodDuration) && /*subscriptionBasePrice*/
      E[4] && m.p(E, P), /*subscriptionTrial*/
      E[3] && /*subscriptionBasePrice*/
      E[4] && h.p(E, P), /*brandingAppearance*/
      (Oe = E[1]) != null && Oe.show_product_description && /*productDetails*/
      E[0].description ? y ? y.p(E, P) : (y = vt(E), y.c(), y.m(o.parentNode, o)) : y && (y.d(1), y = null), /*productDetails*/
      E[0].normalPeriodDuration ? T ? T.p(E, P) : (T = $t(E), T.c(), T.m(s, l)) : T && (T.d(1), T = null);
    },
    d(E) {
      E && (_(e), _(r), _(i), _(o), _(s)), u && u.d(), m && m.d(), h && h.d(E), y && y.d(E), T && T.d();
    }
  };
}
function vr(t) {
  let e = ur(
    /*subscriptionTrial*/
    t[3].periodDuration
  ) + "", n, r;
  return {
    c() {
      n = H(e), r = H(" free trial");
    },
    m(i, o) {
      g(i, n, o), g(i, r, o);
    },
    p: A,
    d(i) {
      i && (_(n), _(r));
    }
  };
}
function $r(t) {
  let e = (
    /*subscriptionBasePrice*/
    t[4].formattedPrice + ""
  ), n;
  return {
    c() {
      n = H(e);
    },
    m(r, i) {
      g(r, n, i);
    },
    p: A,
    d(r) {
      r && _(n);
    }
  };
}
function kr(t) {
  let e;
  return {
    c() {
      e = I("span"), e.textContent = `${/*subscriptionTrial*/
      t[3] && /*subscriptionBasePrice*/
      t[4] && `${/*subscriptionBasePrice*/
      t[4].formattedPrice} after end of trial`}`, b(e, "class", "rcb-product-price-after-trial svelte-1mdrqnh");
    },
    m(n, r) {
      g(n, e, r);
    },
    p: A,
    d(n) {
      n && _(e);
    }
  };
}
function vt(t) {
  let e, n = (
    /*productDetails*/
    t[0].description + ""
  ), r;
  return {
    c() {
      e = I("span"), r = H(n), b(e, "class", "rcb-product-description svelte-1mdrqnh");
    },
    m(i, o) {
      g(i, e, o), L(e, r);
    },
    p(i, o) {
      o & /*productDetails*/
      1 && n !== (n = /*productDetails*/
      i[0].description + "") && te(r, n);
    },
    d(i) {
      i && _(e);
    }
  };
}
function $t(t) {
  let e, n, r = Et(
    /*productDetails*/
    t[0].normalPeriodDuration
  ) + "", i;
  return {
    c() {
      e = I("li"), n = H("Renews "), i = H(r);
    },
    m(o, s) {
      g(o, e, s), L(e, n), L(e, i);
    },
    p(o, s) {
      s & /*productDetails*/
      1 && r !== (r = Et(
        /*productDetails*/
        o[0].normalPeriodDuration
      ) + "") && te(i, r);
    },
    d(o) {
      o && _(e);
    }
  };
}
function Pr(t) {
  var o;
  let e, n, r, i = (
    /*brandingAppearance*/
    ((o = t[1]) == null ? void 0 : o.show_product_description) && kt(t)
  );
  return {
    c() {
      var s;
      e = I("span"), e.textContent = `${/*nonSubscriptionBasePrice*/
      (s = t[5]) == null ? void 0 : s.formattedPrice}`, n = U(), i && i.c(), r = ee(), b(e, "class", "rcb-product-price svelte-1mdrqnh");
    },
    m(s, l) {
      g(s, e, l), g(s, n, l), i && i.m(s, l), g(s, r, l);
    },
    p(s, l) {
      var a;
      /*brandingAppearance*/
      (a = s[1]) != null && a.show_product_description ? i ? i.p(s, l) : (i = kt(s), i.c(), i.m(r.parentNode, r)) : i && (i.d(1), i = null);
    },
    d(s) {
      s && (_(e), _(n), _(r)), i && i.d(s);
    }
  };
}
function kt(t) {
  let e, n = (
    /*productDetails*/
    t[0].description + ""
  ), r;
  return {
    c() {
      e = I("span"), r = H(n), b(e, "class", "rcb-product-description svelte-1mdrqnh");
    },
    m(i, o) {
      g(i, e, o), L(e, r);
    },
    p(i, o) {
      o & /*productDetails*/
      1 && n !== (n = /*productDetails*/
      i[0].description + "") && te(r, n);
    },
    d(i) {
      i && _(e);
    }
  };
}
function Tr(t) {
  let e, n, r = (
    /*productDetails*/
    t[0].title + ""
  ), i, o, s, l = (
    /*isSubscription*/
    t[2] && Ir(t)
  ), a = !/*isSubscription*/
  t[2] && Pr(t);
  return {
    c() {
      e = I("div"), n = I("span"), i = H(r), o = U(), l && l.c(), s = U(), a && a.c(), b(n, "class", "rc-product-title"), b(e, "class", "rcb-pricing-info svelte-1mdrqnh");
    },
    m(c, f) {
      g(c, e, f), L(e, n), L(n, i), L(e, o), l && l.m(e, null), L(e, s), a && a.m(e, null);
    },
    p(c, f) {
      f & /*productDetails*/
      1 && r !== (r = /*productDetails*/
      c[0].title + "") && te(i, r), /*isSubscription*/
      c[2] && l.p(c, f), /*isSubscription*/
      c[2] || a.p(c, f);
    },
    d(c) {
      c && _(e), l && l.d(), a && a.d();
    }
  };
}
function Ar(t) {
  let e, n;
  return e = new de({
    props: {
      $$slots: { default: [Tr] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p(r, [i]) {
      const o = {};
      i & /*$$scope, productDetails, brandingAppearance*/
      515 && (o.$$scope = { dirty: i, ctx: r }), e.$set(o);
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function Or(t, e, n) {
  var m;
  let { productDetails: r } = e, { purchaseOption: i } = e, { brandingAppearance: o = void 0 } = e;
  const s = r.productType === Pe.Subscription, l = i, a = i, c = l == null ? void 0 : l.trial, f = (m = l == null ? void 0 : l.base) == null ? void 0 : m.price, u = a == null ? void 0 : a.basePrice;
  return t.$$set = (h) => {
    "productDetails" in h && n(0, r = h.productDetails), "purchaseOption" in h && n(6, i = h.purchaseOption), "brandingAppearance" in h && n(1, o = h.brandingAppearance);
  }, [
    r,
    o,
    s,
    c,
    f,
    u,
    i
  ];
}
class en extends D {
  constructor(e) {
    super(), M(
      this,
      e,
      Or,
      Ar,
      S,
      {
        productDetails: 0,
        purchaseOption: 6,
        brandingAppearance: 1
      },
      Er
    );
  }
}
const Nr = '<svg width="80" height="80" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" transform="rotate(0 0 0)"><path d="M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 11.5858 20.8358 11.25 21.25 11.25C21.6642 11.25 22 11.5858 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C12.4142 2 12.75 2.33579 12.75 2.75C12.75 3.16421 12.4142 3.5 12 3.5Z" fill="currentColor"/></svg>';
function Ur(t) {
  F(t, "svelte-16h2a8k", "@-webkit-keyframes svelte-16h2a8k-rotating{from{-webkit-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(360deg);-o-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes svelte-16h2a8k-rotating{from{-ms-transform:rotate(0deg);-moz-transform:rotate(0deg);-webkit-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}to{-ms-transform:rotate(360deg);-moz-transform:rotate(360deg);-webkit-transform:rotate(360deg);-o-transform:rotate(360deg);transform:rotate(360deg)}}div.svelte-16h2a8k{width:80px;height:80px;-webkit-animation:svelte-16h2a8k-rotating 2s ease-in-out infinite;-moz-animation:svelte-16h2a8k-rotating 2s ease-in-out infinite;-ms-animation:svelte-16h2a8k-rotating 2s ease-in-out infinite;-o-animation:svelte-16h2a8k-rotating 2s ease-in-out infinite;animation:svelte-16h2a8k-rotating 2s ease-in-out infinite}");
}
function Rr(t) {
  let e;
  return {
    c() {
      e = I("div"), ne(e, "color", "var(--rc-color-accent)"), b(e, "class", "rcb-ui-asset-icon svelte-16h2a8k");
    },
    m(n, r) {
      g(n, e, r), e.innerHTML = Nr;
    },
    p: A,
    i: A,
    o: A,
    d(n) {
      n && _(e);
    }
  };
}
class Lr extends D {
  constructor(e) {
    super(), M(this, e, null, Rr, S, {}, Ur);
  }
}
function Sr(t) {
  F(t, "svelte-l57ojl", ".rcb-modal-loader.svelte-l57ojl{width:100%;flex-grow:1;min-height:100%;display:flex;justify-content:center;align-items:center}");
}
function Mr(t) {
  let e, n, r;
  return n = new Lr({}), {
    c() {
      e = I("div"), k(n.$$.fragment), b(e, "class", "rcb-modal-loader svelte-l57ojl");
    },
    m(i, o) {
      g(i, e, o), v(n, e, null), r = !0;
    },
    p: A,
    i(i) {
      r || (d(n.$$.fragment, i), r = !0);
    },
    o(i) {
      p(n.$$.fragment, i), r = !1;
    },
    d(i) {
      i && _(e), $(n);
    }
  };
}
class tt extends D {
  constructor(e) {
    super(), M(this, e, null, Mr, S, {}, Sr);
  }
}
var X = /* @__PURE__ */ ((t) => (t[t.UnknownError = 0] = "UnknownError", t[t.UserCancelledError = 1] = "UserCancelledError", t[t.StoreProblemError = 2] = "StoreProblemError", t[t.PurchaseNotAllowedError = 3] = "PurchaseNotAllowedError", t[t.PurchaseInvalidError = 4] = "PurchaseInvalidError", t[t.ProductNotAvailableForPurchaseError = 5] = "ProductNotAvailableForPurchaseError", t[t.ProductAlreadyPurchasedError = 6] = "ProductAlreadyPurchasedError", t[t.ReceiptAlreadyInUseError = 7] = "ReceiptAlreadyInUseError", t[t.InvalidReceiptError = 8] = "InvalidReceiptError", t[t.MissingReceiptFileError = 9] = "MissingReceiptFileError", t[t.NetworkError = 10] = "NetworkError", t[t.InvalidCredentialsError = 11] = "InvalidCredentialsError", t[t.UnexpectedBackendResponseError = 12] = "UnexpectedBackendResponseError", t[t.InvalidAppUserIdError = 14] = "InvalidAppUserIdError", t[t.OperationAlreadyInProgressError = 15] = "OperationAlreadyInProgressError", t[t.UnknownBackendError = 16] = "UnknownBackendError", t[t.InvalidAppleSubscriptionKeyError = 17] = "InvalidAppleSubscriptionKeyError", t[t.IneligibleError = 18] = "IneligibleError", t[t.InsufficientPermissionsError = 19] = "InsufficientPermissionsError", t[t.PaymentPendingError = 20] = "PaymentPendingError", t[t.InvalidSubscriberAttributesError = 21] = "InvalidSubscriberAttributesError", t[t.LogOutWithAnonymousUserError = 22] = "LogOutWithAnonymousUserError", t[t.ConfigurationError = 23] = "ConfigurationError", t[t.UnsupportedError = 24] = "UnsupportedError", t[t.EmptySubscriberAttributesError = 25] = "EmptySubscriberAttributesError", t[t.CustomerInfoError = 28] = "CustomerInfoError", t[t.SignatureVerificationError = 36] = "SignatureVerificationError", t[t.InvalidEmailError = 38] = "InvalidEmailError", t))(X || {});
class ye {
  static getPublicMessage(e) {
    switch (e) {
      case 0:
        return "Unknown error.";
      case 1:
        return "Purchase was cancelled.";
      case 2:
        return "There was a problem with the store.";
      case 3:
        return "The device or user is not allowed to make the purchase.";
      case 4:
        return "One or more of the arguments provided are invalid.";
      case 5:
        return "The product is not available for purchase.";
      case 6:
        return "This product is already active for the user.";
      case 7:
        return "There is already another active subscriber using the same receipt.";
      case 8:
        return "The receipt is not valid.";
      case 9:
        return "The receipt is missing.";
      case 10:
        return "Error performing request. Please check your network connection and try again.";
      case 11:
        return "There was a credentials issue. Check the underlying error for more details.";
      case 12:
        return "Received unexpected response from the backend.";
      case 14:
        return "The app user id is not valid.";
      case 15:
        return "The operation is already in progress.";
      case 16:
        return "There was an unknown backend error.";
      case 17:
        return "Apple Subscription Key is invalid or not present. In order to provide subscription offers, you must first generate a subscription key. Please see https://docs.revenuecat.com/docs/ios-subscription-offers for more info.";
      case 18:
        return "The User is ineligible for that action.";
      case 19:
        return "App does not have sufficient permissions to make purchases.";
      case 20:
        return "The payment is pending.";
      case 21:
        return "One or more of the attributes sent could not be saved.";
      case 22:
        return "Called logOut but the current user is anonymous.";
      case 23:
        return "There is an issue with your configuration. Check the underlying error for more details.";
      case 24:
        return "There was a problem with the operation. Looks like we doesn't support that yet. Check the underlying error for more details.";
      case 25:
        return "A request for subscriber attributes returned none.";
      case 28:
        return "There was a problem related to the customer info.";
      case 36:
        return "Request failed signature verification. Please see https://rev.cat/trusted-entitlements for more info.";
      case 38:
        return "Email is not valid. Please provide a valid email address.";
    }
  }
  static getErrorCodeForBackendErrorCode(e) {
    switch (e) {
      case 7101:
      case 7773:
        return 2;
      case 7102:
        return 7;
      case 7103:
        return 8;
      case 7107:
      case 7224:
      case 7225:
        return 11;
      case 7105:
      case 7106:
      case 7814:
        return 4;
      case 7772:
        return 6;
      case 7220:
        return 14;
      case 7229:
        return 2;
      case 7230:
      case 7e3:
        return 23;
      case 7231:
        return 2;
      case 7232:
        return 18;
      case 7263:
      case 7264:
        return 21;
      case 7104:
      case 7234:
      case 7226:
      case 7110:
        return 12;
      case 7662:
        return 24;
      case 7012:
      case 7834:
        return 38;
    }
  }
  static convertCodeToBackendErrorCode(e) {
    return e in tn ? e : null;
  }
  static convertPurchaseFlowErrorCodeToErrorCode(e) {
    switch (e) {
      case K.ErrorSettingUpPurchase:
        return 2;
      case K.ErrorChargingPayment:
        return 20;
      case K.NetworkError:
        return 10;
      case K.MissingEmailError:
        return 4;
      case K.StripeError:
        return 2;
      case K.UnknownError:
        return 0;
      case K.AlreadyPurchasedError:
        return 6;
    }
  }
}
var tn = /* @__PURE__ */ ((t) => (t[t.BackendInvalidPlatform = 7e3] = "BackendInvalidPlatform", t[t.BackendInvalidEmail = 7012] = "BackendInvalidEmail", t[t.BackendStoreProblem = 7101] = "BackendStoreProblem", t[t.BackendCannotTransferPurchase = 7102] = "BackendCannotTransferPurchase", t[t.BackendInvalidReceiptToken = 7103] = "BackendInvalidReceiptToken", t[t.BackendInvalidAppStoreSharedSecret = 7104] = "BackendInvalidAppStoreSharedSecret", t[t.BackendInvalidPaymentModeOrIntroPriceNotProvided = 7105] = "BackendInvalidPaymentModeOrIntroPriceNotProvided", t[t.BackendProductIdForGoogleReceiptNotProvided = 7106] = "BackendProductIdForGoogleReceiptNotProvided", t[t.BackendInvalidPlayStoreCredentials = 7107] = "BackendInvalidPlayStoreCredentials", t[t.BackendInternalServerError = 7110] = "BackendInternalServerError", t[t.BackendEmptyAppUserId = 7220] = "BackendEmptyAppUserId", t[t.BackendInvalidAuthToken = 7224] = "BackendInvalidAuthToken", t[t.BackendInvalidAPIKey = 7225] = "BackendInvalidAPIKey", t[t.BackendBadRequest = 7226] = "BackendBadRequest", t[t.BackendPlayStoreQuotaExceeded = 7229] = "BackendPlayStoreQuotaExceeded", t[t.BackendPlayStoreInvalidPackageName = 7230] = "BackendPlayStoreInvalidPackageName", t[t.BackendPlayStoreGenericError = 7231] = "BackendPlayStoreGenericError", t[t.BackendUserIneligibleForPromoOffer = 7232] = "BackendUserIneligibleForPromoOffer", t[t.BackendInvalidAppleSubscriptionKey = 7234] = "BackendInvalidAppleSubscriptionKey", t[t.BackendInvalidSubscriberAttributes = 7263] = "BackendInvalidSubscriberAttributes", t[t.BackendInvalidSubscriberAttributesBody = 7264] = "BackendInvalidSubscriberAttributesBody", t[t.BackendProductIDsMalformed = 7662] = "BackendProductIDsMalformed", t[t.BackendAlreadySubscribedError = 7772] = "BackendAlreadySubscribedError", t[t.BackendPaymentGatewayGenericError = 7773] = "BackendPaymentGatewayGenericError", t[t.BackendOfferNotFound = 7814] = "BackendOfferNotFound", t[t.BackendNoMXRecordsFound = 7834] = "BackendNoMXRecordsFound", t))(tn || {});
class Q extends Error {
  constructor(n, r, i, o) {
    super(r);
    N(this, "toString", () => `PurchasesError(code: ${X[this.errorCode]}, message: ${this.message})`);
    this.errorCode = n, this.underlyingErrorMessage = i, this.extra = o;
  }
  /** @internal */
  static getForBackendError(n, r) {
    const i = ye.getErrorCodeForBackendErrorCode(n);
    return new Q(
      i,
      ye.getPublicMessage(i),
      r,
      { backendErrorCode: n }
    );
  }
  /** @internal */
  static getForPurchasesFlowError(n) {
    return new Q(
      ye.convertPurchaseFlowErrorCodeToErrorCode(
        n.errorCode
      ),
      n.message,
      n.underlyingErrorMessage
    );
  }
}
class Dr extends Error {
  constructor() {
    super("Purchases must be configured before calling getInstance");
  }
}
var be = /* @__PURE__ */ ((t) => (t.Started = "started", t.InProgress = "in_progress", t.Succeeded = "succeeded", t.Failed = "failed", t))(be || {}), ce = /* @__PURE__ */ ((t) => (t[t.SetupIntentCreationFailed = 1] = "SetupIntentCreationFailed", t[t.PaymentMethodCreationFailed = 2] = "PaymentMethodCreationFailed", t[t.PaymentChargeFailed = 3] = "PaymentChargeFailed", t[t.SetupIntentCompletionFailed = 4] = "SetupIntentCompletionFailed", t[t.AlreadyPurchased = 5] = "AlreadyPurchased", t))(ce || {}), K = /* @__PURE__ */ ((t) => (t[t.ErrorSettingUpPurchase = 0] = "ErrorSettingUpPurchase", t[t.ErrorChargingPayment = 1] = "ErrorChargingPayment", t[t.UnknownError = 2] = "UnknownError", t[t.NetworkError = 3] = "NetworkError", t[t.StripeError = 4] = "StripeError", t[t.MissingEmailError = 5] = "MissingEmailError", t[t.AlreadyPurchasedError = 6] = "AlreadyPurchasedError", t))(K || {});
class x extends Error {
  constructor(e, n, r, i, o) {
    super(n), this.errorCode = e, this.underlyingErrorMessage = r, this.purchasesErrorCode = i, this.extra = o;
  }
  isRecoverable() {
    switch (this.errorCode) {
      case 3:
      case 5:
        return !0;
      case 0:
      case 1:
      case 6:
      case 4:
      case 2:
        return !1;
    }
  }
  getPublicErrorMessage(e) {
    var r;
    const n = ((r = this.extra) == null ? void 0 : r.backendErrorCode) ?? this.purchasesErrorCode ?? this.errorCode;
    switch (this.errorCode) {
      case 2:
        return `An unknown error occurred. Error code: ${n}.`;
      case 0:
        return `Purchase not started due to an error. Error code: ${n}.`;
      case 1:
        return "Payment failed.";
      case 3:
        return "Network error. Please check your internet connection.";
      case 4:
        return this.message;
      case 5:
        return "Email is required to complete the purchase.";
      case 6:
        return (e == null ? void 0 : e.productType) === Pe.Subscription ? "You are already subscribed to this product." : "You have already purchased this product.";
    }
  }
  static fromPurchasesError(e, n) {
    let r;
    return e.errorCode === X.ProductAlreadyPurchasedError ? r = 6 : e.errorCode === X.InvalidEmailError ? r = 5 : e.errorCode === X.NetworkError ? r = 3 : r = n, new x(
      r,
      e.message,
      e.underlyingErrorMessage,
      e.errorCode,
      e.extra
    );
  }
}
class Br {
  constructor(e, n = 10) {
    N(this, "operationSessionId", null);
    N(this, "backend");
    N(this, "maxNumberAttempts");
    N(this, "waitMSBetweenAttempts", 1e3);
    this.backend = e, this.maxNumberAttempts = n;
  }
  async startPurchase(e, n, r, i, o) {
    try {
      const s = await this.backend.postPurchase(
        e,
        n,
        i,
        o,
        r
      );
      return this.operationSessionId = s.operation_session_id, s;
    } catch (s) {
      if (s instanceof Q)
        throw x.fromPurchasesError(
          s,
          0
          /* ErrorSettingUpPurchase */
        );
      {
        const l = "Unknown error starting purchase: " + String(s);
        throw j.errorLog(l), new x(
          2,
          l
        );
      }
    }
  }
  async pollCurrentPurchaseForCompletion() {
    const e = this.operationSessionId;
    if (!e)
      throw new x(
        0,
        "No purchase in progress"
      );
    return new Promise((n, r) => {
      const i = (o = 1) => {
        if (o > this.maxNumberAttempts) {
          this.clearPurchaseInProgress(), r(
            new x(
              2,
              "Max attempts reached trying to get successful purchase status"
            )
          );
          return;
        }
        this.backend.getCheckoutStatus(e).then((s) => {
          switch (s.operation.status) {
            case be.Started:
            case be.InProgress:
              setTimeout(
                () => i(o + 1),
                this.waitMSBetweenAttempts
              );
              break;
            case be.Succeeded:
              this.clearPurchaseInProgress(), n();
              return;
            case be.Failed:
              this.clearPurchaseInProgress(), this.handlePaymentError(
                s.operation.error,
                r
              );
          }
        }).catch((s) => {
          const l = x.fromPurchasesError(
            s,
            3
            /* NetworkError */
          );
          r(l);
        });
      };
      i();
    });
  }
  clearPurchaseInProgress() {
    this.operationSessionId = null;
  }
  handlePaymentError(e, n) {
    if (e == null) {
      n(
        new x(
          2,
          "Got an error status but error field is empty."
        )
      );
      return;
    }
    switch (e.code) {
      case ce.SetupIntentCreationFailed:
        n(
          new x(
            0,
            "Setup intent creation failed"
          )
        );
        return;
      case ce.PaymentMethodCreationFailed:
        n(
          new x(
            0,
            "Payment method creation failed"
          )
        );
        return;
      case ce.PaymentChargeFailed:
        n(
          new x(
            1,
            "Payment charge failed"
          )
        );
        return;
      case ce.SetupIntentCompletionFailed:
        n(
          new x(
            0,
            "Setup intent completion failed"
          )
        );
        return;
      case ce.AlreadyPurchased:
        n(
          new x(
            6,
            "Purchased was already completed"
          )
        );
        return;
      default:
        n(
          new x(
            2,
            "Unknown error code received"
          )
        );
        return;
    }
  }
}
const Cr = `<svg width="96" height="96" viewBox="0 0 124 124" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <circle cx="62" cy="62" r="62" fill="currentColor"/>
    <path d="M87.6668 41.504L82.4968 36.334L62.0002 56.8307L41.5035 36.334L36.3335 41.504L56.8302 62.0006L36.3335 82.4973L41.5035 87.6673L62.0002 67.1706L82.4968 87.6673L87.6668 82.4973L67.1702 62.0006L87.6668 41.504Z"
          fill="white"/>
</svg>
`;
function Fr(t) {
  F(t, "svelte-7wiquz", ".rcb-ui-asset-icon.svelte-7wiquz{width:96px;height:96px;margin:0 auto}");
}
function jr(t) {
  let e;
  return {
    c() {
      e = I("div"), ne(e, "color", "var(--rc-color-error)"), b(e, "class", "rcb-ui-asset-icon svelte-7wiquz");
    },
    m(n, r) {
      g(n, e, r), e.innerHTML = Cr;
    },
    p: A,
    i: A,
    o: A,
    d(n) {
      n && _(e);
    }
  };
}
class Hr extends D {
  constructor(e) {
    super(), M(this, e, null, jr, S, {}, Fr);
  }
}
function xr(t) {
  F(t, "svelte-2xwwo", "button.svelte-2xwwo{border:none;border-radius:var(--rc-shape-input-button-border-radius);font-size:16px;cursor:pointer;height:56px;color:var(--rc-color-grey-text-dark);background-color:var(--rc-color-grey-ui-dark);display:flex;align-items:center;justify-content:center;-webkit-tap-highlight-color:rgba(0, 0, 0, 0);-webkit-tap-highlight-color:transparent}button.svelte-2xwwo:focus,button.svelte-2xwwo:active{outline:2px solid var(--rc-color-focus)}button.intent-primary.svelte-2xwwo{background-color:var(--rc-color-primary);color:var(--rc-color-primary-text);font-size:16px}button.svelte-2xwwo:disabled{color:var(--rc-color-grey-text-light);background-color:var(--rc-color-grey-ui-dark)}button.intent-primary.svelte-2xwwo:disabled{color:var(--rc-color-grey-text-light);background-color:var(--rc-color-grey-ui-dark)}");
}
function qr(t) {
  let e, n, r, i, o;
  const s = (
    /*#slots*/
    t[5].default
  ), l = q(
    s,
    t,
    /*$$scope*/
    t[4],
    null
  );
  return {
    c() {
      e = I("button"), l && l.c(), b(e, "class", n = We(`intent-${/*intent*/
      t[0]}`) + " svelte-2xwwo"), e.disabled = /*disabled*/
      t[1], b(
        e,
        "data-testid",
        /*testId*/
        t[2]
      ), b(
        e,
        "type",
        /*type*/
        t[3]
      );
    },
    m(a, c) {
      g(a, e, c), l && l.m(e, null), r = !0, i || (o = $e(
        e,
        "click",
        /*click_handler*/
        t[6]
      ), i = !0);
    },
    p(a, [c]) {
      l && l.p && (!r || c & /*$$scope*/
      16) && V(
        l,
        s,
        a,
        /*$$scope*/
        a[4],
        r ? G(
          s,
          /*$$scope*/
          a[4],
          c,
          null
        ) : Y(
          /*$$scope*/
          a[4]
        ),
        null
      ), (!r || c & /*intent*/
      1 && n !== (n = We(`intent-${/*intent*/
      a[0]}`) + " svelte-2xwwo")) && b(e, "class", n), (!r || c & /*disabled*/
      2) && (e.disabled = /*disabled*/
      a[1]), (!r || c & /*testId*/
      4) && b(
        e,
        "data-testid",
        /*testId*/
        a[2]
      ), (!r || c & /*type*/
      8) && b(
        e,
        "type",
        /*type*/
        a[3]
      );
    },
    i(a) {
      r || (d(l, a), r = !0);
    },
    o(a) {
      p(l, a), r = !1;
    },
    d(a) {
      a && _(e), l && l.d(a), i = !1, o();
    }
  };
}
function Gr(t, e, n) {
  let { $$slots: r = {}, $$scope: i } = e, { intent: o = "primary" } = e, { disabled: s = !1 } = e, { testId: l = void 0 } = e, { type: a = void 0 } = e;
  function c(f) {
    Xt.call(this, t, f);
  }
  return t.$$set = (f) => {
    "intent" in f && n(0, o = f.intent), "disabled" in f && n(1, s = f.disabled), "testId" in f && n(2, l = f.testId), "type" in f && n(3, a = f.type), "$$scope" in f && n(4, i = f.$$scope);
  }, [o, s, l, a, i, r, c];
}
class nt extends D {
  constructor(e) {
    super(), M(
      this,
      e,
      Gr,
      qr,
      S,
      {
        intent: 0,
        disabled: 1,
        testId: 2,
        type: 3
      },
      xr
    );
  }
}
function Vr(t) {
  F(t, "svelte-1f9z0o8", "footer.svelte-1f9z0o8{display:flex;flex-direction:column}");
}
function Yr(t) {
  let e, n;
  const r = (
    /*#slots*/
    t[1].default
  ), i = q(
    r,
    t,
    /*$$scope*/
    t[0],
    null
  );
  return {
    c() {
      e = I("footer"), i && i.c(), b(e, "class", "rcb-modal-footer svelte-1f9z0o8");
    },
    m(o, s) {
      g(o, e, s), i && i.m(e, null), n = !0;
    },
    p(o, [s]) {
      i && i.p && (!n || s & /*$$scope*/
      1) && V(
        i,
        r,
        o,
        /*$$scope*/
        o[0],
        n ? G(
          r,
          /*$$scope*/
          o[0],
          s,
          null
        ) : Y(
          /*$$scope*/
          o[0]
        ),
        null
      );
    },
    i(o) {
      n || (d(i, o), n = !0);
    },
    o(o) {
      p(i, o), n = !1;
    },
    d(o) {
      o && _(e), i && i.d(o);
    }
  };
}
function zr(t, e, n) {
  let { $$slots: r = {}, $$scope: i } = e;
  return t.$$set = (o) => {
    "$$scope" in o && n(0, i = o.$$scope);
  }, [i, r];
}
class rt extends D {
  constructor(e) {
    super(), M(this, e, zr, Yr, S, {}, Vr);
  }
}
function Wr(t) {
  F(t, "svelte-6o8e90", '.column.svelte-6o8e90{display:flex;flex-direction:column;justify-content:flex-start;gap:var(--gap, "8px");flex-grow:1}');
}
function Kr(t) {
  let e, n, r;
  const i = (
    /*#slots*/
    t[2].default
  ), o = q(
    i,
    t,
    /*$$scope*/
    t[1],
    null
  );
  return {
    c() {
      e = I("div"), o && o.c(), b(e, "class", "column svelte-6o8e90"), b(e, "style", n = `--gap:${/*gutter*/
      t[0]};`);
    },
    m(s, l) {
      g(s, e, l), o && o.m(e, null), r = !0;
    },
    p(s, [l]) {
      o && o.p && (!r || l & /*$$scope*/
      2) && V(
        o,
        i,
        s,
        /*$$scope*/
        s[1],
        r ? G(
          i,
          /*$$scope*/
          s[1],
          l,
          null
        ) : Y(
          /*$$scope*/
          s[1]
        ),
        null
      ), (!r || l & /*gutter*/
      1 && n !== (n = `--gap:${/*gutter*/
      s[0]};`)) && b(e, "style", n);
    },
    i(s) {
      r || (d(o, s), r = !0);
    },
    o(s) {
      p(o, s), r = !1;
    },
    d(s) {
      s && _(e), o && o.d(s);
    }
  };
}
function Qr(t, e, n) {
  let { $$slots: r = {}, $$scope: i } = e, { gutter: o = "8px" } = e;
  return t.$$set = (s) => {
    "gutter" in s && n(0, o = s.gutter), "$$scope" in s && n(1, i = s.$$scope);
  }, [o, i, r];
}
class Te extends D {
  constructor(e) {
    super(), M(this, e, Qr, Kr, S, { gutter: 0 }, Wr);
  }
}
const Xr = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='mdi_close'%3e%3cpath%20id='Vector'%20d='M19%206.41L17.59%205L12%2010.59L6.41%205L5%206.41L10.59%2012L5%2017.59L6.41%2019L12%2013.41L17.59%2019L19%2017.59L13.41%2012L19%206.41Z'%20fill='%23767676'/%3e%3c/g%3e%3c/svg%3e";
function Zr(t) {
  F(t, "svelte-1hv9ta1", ".close-button.svelte-1hv9ta1{border:none;cursor:pointer;background-color:transparent;padding:0px;height:24px;border-radius:50%}.close-button.svelte-1hv9ta1:focus{outline:2px solid var(--rc-color-focus)}");
}
function Jr(t) {
  let e, n, r, i, o;
  return {
    c() {
      e = I("button"), n = I("img"), Ee(n.src, r = Xr) || b(n, "src", r), b(n, "alt", "close"), b(e, "class", "close-button svelte-1hv9ta1"), e.disabled = /*disabled*/
      t[0];
    },
    m(s, l) {
      g(s, e, l), L(e, n), i || (o = $e(
        e,
        "click",
        /*click_handler*/
        t[1]
      ), i = !0);
    },
    p(s, [l]) {
      l & /*disabled*/
      1 && (e.disabled = /*disabled*/
      s[0]);
    },
    i: A,
    o: A,
    d(s) {
      s && _(e), i = !1, o();
    }
  };
}
function ei(t, e, n) {
  let { disabled: r = !1 } = e;
  function i(o) {
    Xt.call(this, t, o);
  }
  return t.$$set = (o) => {
    "disabled" in o && n(0, r = o.disabled);
  }, [r, i];
}
class it extends D {
  constructor(e) {
    super(), M(this, e, ei, Jr, S, { disabled: 0 }, Zr);
  }
}
function ti(t) {
  F(t, "svelte-44qpq9", ".rcb-app-icon.svelte-44qpq9{width:40px;height:40px;border-radius:12px;box-shadow:0px 1px 10px 0px rgba(0, 0, 0, 0.1);margin-right:16px}.rcb-app-icon-picture-container.svelte-44qpq9{height:40px}.rcb-app-icon.loading.svelte-44qpq9{background-color:gray}");
}
function ni(t) {
  let e;
  return {
    c() {
      e = I("div"), b(e, "class", "rcb-app-icon loading svelte-44qpq9");
    },
    m(n, r) {
      g(n, e, r);
    },
    p: A,
    d(n) {
      n && _(e);
    }
  };
}
function ri(t) {
  let e, n, r, i, o, s;
  return {
    c() {
      e = I("picture"), n = I("source"), i = U(), o = I("img"), b(n, "type", "image/webp"), Mn(n, r = /*srcWebp*/
      t[1]) || b(n, "srcset", r), b(o, "class", "rcb-app-icon svelte-44qpq9"), Ee(o.src, s = /*src*/
      t[0]) || b(o, "src", s), b(o, "alt", "App icon"), b(e, "class", "rcb-app-icon-picture-container svelte-44qpq9");
    },
    m(l, a) {
      g(l, e, a), L(e, n), L(e, i), L(e, o);
    },
    p(l, a) {
      a & /*srcWebp*/
      2 && r !== (r = /*srcWebp*/
      l[1]) && b(n, "srcset", r), a & /*src*/
      1 && !Ee(o.src, s = /*src*/
      l[0]) && b(o, "src", s);
    },
    d(l) {
      l && _(e);
    }
  };
}
function ii(t) {
  let e;
  function n(o, s) {
    return (
      /*src*/
      o[0] !== null ? ri : ni
    );
  }
  let r = n(t), i = r(t);
  return {
    c() {
      i.c(), e = ee();
    },
    m(o, s) {
      i.m(o, s), g(o, e, s);
    },
    p(o, [s]) {
      r === (r = n(o)) && i ? i.p(o, s) : (i.d(1), i = r(o), i && (i.c(), i.m(e.parentNode, e)));
    },
    i: A,
    o: A,
    d(o) {
      o && _(e), i.d(o);
    }
  };
}
function oi(t, e, n) {
  let { src: r = null } = e, { srcWebp: i = null } = e;
  return t.$$set = (o) => {
    "src" in o && n(0, r = o.src), "srcWebp" in o && n(1, i = o.srcWebp);
  }, [r, i];
}
class nn extends D {
  constructor(e) {
    super(), M(this, e, oi, ii, S, { src: 0, srcWebp: 1 }, ti);
  }
}
const Ue = (t) => `https://da08ctfrofx1b.cloudfront.net/${t}`;
function si(t) {
  F(t, "svelte-10uf5fq", ".app-title.svelte-10uf5fq{font-weight:500;margin:8px 0;font-size:16px}.rcb-header-layout__business-info.svelte-10uf5fq{display:flex;align-items:center}");
}
function li(t) {
  let e, n;
  return e = new nn({}), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p: A,
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function ai(t) {
  let e, n, r = (
    /*brandingInfo*/
    t[0].seller_company_name + ""
  ), i, o, s = (
    /*brandingInfo*/
    t[0].app_icon_webp !== null && /*brandingInfo*/
    t[0].app_icon !== null && Pt(t)
  );
  return {
    c() {
      s && s.c(), e = U(), n = I("span"), i = H(r), b(n, "class", "app-title svelte-10uf5fq");
    },
    m(l, a) {
      s && s.m(l, a), g(l, e, a), g(l, n, a), L(n, i), o = !0;
    },
    p(l, a) {
      /*brandingInfo*/
      l[0].app_icon_webp !== null && /*brandingInfo*/
      l[0].app_icon !== null ? s ? (s.p(l, a), a & /*brandingInfo*/
      1 && d(s, 1)) : (s = Pt(l), s.c(), d(s, 1), s.m(e.parentNode, e)) : s && (z(), p(s, 1, 1, () => {
        s = null;
      }), W()), (!o || a & /*brandingInfo*/
      1) && r !== (r = /*brandingInfo*/
      l[0].seller_company_name + "") && te(i, r);
    },
    i(l) {
      o || (d(s), o = !0);
    },
    o(l) {
      p(s), o = !1;
    },
    d(l) {
      l && (_(e), _(n)), s && s.d(l);
    }
  };
}
function Pt(t) {
  let e, n;
  return e = new nn({
    props: {
      src: Ue(
        /*brandingInfo*/
        t[0].app_icon
      ),
      srcWebp: Ue(
        /*brandingInfo*/
        t[0].app_icon_webp
      )
    }
  }), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p(r, i) {
      const o = {};
      i & /*brandingInfo*/
      1 && (o.src = Ue(
        /*brandingInfo*/
        r[0].app_icon
      )), i & /*brandingInfo*/
      1 && (o.srcWebp = Ue(
        /*brandingInfo*/
        r[0].app_icon_webp
      )), e.$set(o);
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function ci(t) {
  let e, n, r, i;
  const o = [ai, li], s = [];
  function l(a, c) {
    return (
      /*brandingInfo*/
      a[0] !== null ? 0 : 1
    );
  }
  return n = l(t), r = s[n] = o[n](t), {
    c() {
      e = I("div"), r.c(), b(e, "class", "rcb-header-layout__business-info svelte-10uf5fq");
    },
    m(a, c) {
      g(a, e, c), s[n].m(e, null), i = !0;
    },
    p(a, [c]) {
      let f = n;
      n = l(a), n === f ? s[n].p(a, c) : (z(), p(s[f], 1, 1, () => {
        s[f] = null;
      }), W(), r = s[n], r ? r.p(a, c) : (r = s[n] = o[n](a), r.c()), d(r, 1), r.m(e, null));
    },
    i(a) {
      i || (d(r), i = !0);
    },
    o(a) {
      p(r), i = !1;
    },
    d(a) {
      a && _(e), s[n].d();
    }
  };
}
function ui(t, e, n) {
  let { brandingInfo: r = null } = e;
  return t.$$set = (i) => {
    "brandingInfo" in i && n(0, r = i.brandingInfo);
  }, [r];
}
class rn extends D {
  constructor(e) {
    super(), M(this, e, ui, ci, S, { brandingInfo: 0 }, si);
  }
}
function fi(t) {
  F(t, "svelte-17puakv", ".rcb-post-purchase-header-layout.svelte-17puakv{display:flex;justify-content:space-between;align-items:center;width:100%;margin-top:-4px}");
}
function di(t) {
  let e, n, r, i, o;
  return n = new rn({
    props: { brandingInfo: (
      /*brandingInfo*/
      t[0]
    ) }
  }), i = new it({}), i.$on("click", function() {
    fe(
      /*onClose*/
      t[1]
    ) && t[1].apply(this, arguments);
  }), {
    c() {
      e = I("div"), k(n.$$.fragment), r = U(), k(i.$$.fragment), b(e, "class", "rcb-post-purchase-header-layout svelte-17puakv");
    },
    m(s, l) {
      g(s, e, l), v(n, e, null), L(e, r), v(i, e, null), o = !0;
    },
    p(s, l) {
      t = s;
      const a = {};
      l & /*brandingInfo*/
      1 && (a.brandingInfo = /*brandingInfo*/
      t[0]), n.$set(a);
    },
    i(s) {
      o || (d(n.$$.fragment, s), d(i.$$.fragment, s), o = !0);
    },
    o(s) {
      p(n.$$.fragment, s), p(i.$$.fragment, s), o = !1;
    },
    d(s) {
      s && _(e), $(n), $(i);
    }
  };
}
function pi(t) {
  let e, n;
  return e = new de({
    props: {
      as: "header",
      $$slots: { default: [di] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p(r, [i]) {
      const o = {};
      i & /*$$scope, onClose, brandingInfo*/
      7 && (o.$$scope = { dirty: i, ctx: r }), e.$set(o);
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function mi(t, e, n) {
  let { brandingInfo: r = null } = e, { onClose: i } = e;
  return t.$$set = (o) => {
    "brandingInfo" in o && n(0, r = o.brandingInfo), "onClose" in o && n(1, i = o.onClose);
  }, [r, i];
}
class _i extends D {
  constructor(e) {
    super(), M(this, e, mi, pi, S, { brandingInfo: 0, onClose: 1 }, fi);
  }
}
function gi(t) {
  F(t, "svelte-idou50", ".rcb-modal-message.svelte-idou50{width:100%;min-height:160px;display:flex;justify-content:center;align-items:center;flex-direction:column;text-align:center;margin-bottom:16px;margin-top:16px}.title.svelte-idou50{font-size:24px;line-height:1.25em}.subtitle.svelte-idou50{font-size:16px;line-height:1.25em;overflow-wrap:anywhere}");
}
const hi = (t) => ({}), Tt = (t) => ({});
function bi(t) {
  let e, n, r, i, o;
  const s = (
    /*#slots*/
    t[5].default
  ), l = q(
    s,
    t,
    /*$$scope*/
    t[6],
    null
  );
  return {
    c() {
      e = I("span"), n = H(
        /*title*/
        t[2]
      ), r = U(), i = I("span"), l && l.c(), b(e, "class", "title svelte-idou50"), b(i, "class", "subtitle svelte-idou50");
    },
    m(a, c) {
      g(a, e, c), L(e, n), g(a, r, c), g(a, i, c), l && l.m(i, null), o = !0;
    },
    p(a, c) {
      (!o || c & /*title*/
      4) && te(
        n,
        /*title*/
        a[2]
      ), l && l.p && (!o || c & /*$$scope*/
      64) && V(
        l,
        s,
        a,
        /*$$scope*/
        a[6],
        o ? G(
          s,
          /*$$scope*/
          a[6],
          c,
          null
        ) : Y(
          /*$$scope*/
          a[6]
        ),
        null
      );
    },
    i(a) {
      o || (d(l, a), o = !0);
    },
    o(a) {
      p(l, a), o = !1;
    },
    d(a) {
      a && (_(e), _(r), _(i)), l && l.d(a);
    }
  };
}
function wi(t) {
  let e, n, r;
  const i = (
    /*#slots*/
    t[5].icon
  ), o = q(
    i,
    t,
    /*$$scope*/
    t[6],
    Tt
  );
  return n = new Te({
    props: {
      gutter: "16px",
      $$slots: { default: [bi] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      o && o.c(), e = U(), k(n.$$.fragment);
    },
    m(s, l) {
      o && o.m(s, l), g(s, e, l), v(n, s, l), r = !0;
    },
    p(s, l) {
      o && o.p && (!r || l & /*$$scope*/
      64) && V(
        o,
        i,
        s,
        /*$$scope*/
        s[6],
        r ? G(
          i,
          /*$$scope*/
          s[6],
          l,
          hi
        ) : Y(
          /*$$scope*/
          s[6]
        ),
        Tt
      );
      const a = {};
      l & /*$$scope, title*/
      68 && (a.$$scope = { dirty: l, ctx: s }), n.$set(a);
    },
    i(s) {
      r || (d(o, s), d(n.$$.fragment, s), r = !0);
    },
    o(s) {
      p(o, s), p(n.$$.fragment, s), r = !1;
    },
    d(s) {
      s && _(e), o && o.d(s), $(n, s);
    }
  };
}
function yi(t) {
  let e, n, r;
  return n = new Te({
    props: {
      gutter: "48px",
      $$slots: { default: [wi] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      e = I("div"), k(n.$$.fragment), b(e, "class", "rcb-modal-message svelte-idou50"), b(
        e,
        "data-type",
        /*type*/
        t[3]
      );
    },
    m(i, o) {
      g(i, e, o), v(n, e, null), r = !0;
    },
    p(i, o) {
      const s = {};
      o & /*$$scope, title*/
      68 && (s.$$scope = { dirty: o, ctx: i }), n.$set(s), (!r || o & /*type*/
      8) && b(
        e,
        "data-type",
        /*type*/
        i[3]
      );
    },
    i(i) {
      r || (d(n.$$.fragment, i), r = !0);
    },
    o(i) {
      p(n.$$.fragment, i), r = !1;
    },
    d(i) {
      i && _(e), $(n);
    }
  };
}
function Ei(t) {
  let e;
  return {
    c() {
      e = H(
        /*closeButtonTitle*/
        t[4]
      );
    },
    m(n, r) {
      g(n, e, r);
    },
    p(n, r) {
      r & /*closeButtonTitle*/
      16 && te(
        e,
        /*closeButtonTitle*/
        n[4]
      );
    },
    d(n) {
      n && _(e);
    }
  };
}
function Ii(t) {
  let e, n;
  return e = new nt({
    props: {
      type: "submit",
      $$slots: { default: [Ei] },
      $$scope: { ctx: t }
    }
  }), e.$on("click", function() {
    fe(
      /*onContinue*/
      t[1]
    ) && t[1].apply(this, arguments);
  }), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p(r, i) {
      t = r;
      const o = {};
      i & /*$$scope, closeButtonTitle*/
      80 && (o.$$scope = { dirty: i, ctx: t }), e.$set(o);
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function vi(t) {
  let e, n, r, i, o, s;
  return e = new _i({
    props: {
      brandingInfo: (
        /*brandingInfo*/
        t[0]
      ),
      onClose: (
        /*onContinue*/
        t[1]
      )
    }
  }), r = new de({
    props: {
      $$slots: { default: [yi] },
      $$scope: { ctx: t }
    }
  }), o = new rt({
    props: {
      $$slots: { default: [Ii] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      k(e.$$.fragment), n = U(), k(r.$$.fragment), i = U(), k(o.$$.fragment);
    },
    m(l, a) {
      v(e, l, a), g(l, n, a), v(r, l, a), g(l, i, a), v(o, l, a), s = !0;
    },
    p(l, a) {
      const c = {};
      a & /*brandingInfo*/
      1 && (c.brandingInfo = /*brandingInfo*/
      l[0]), a & /*onContinue*/
      2 && (c.onClose = /*onContinue*/
      l[1]), e.$set(c);
      const f = {};
      a & /*$$scope, type, title*/
      76 && (f.$$scope = { dirty: a, ctx: l }), r.$set(f);
      const u = {};
      a & /*$$scope, onContinue, closeButtonTitle*/
      82 && (u.$$scope = { dirty: a, ctx: l }), o.$set(u);
    },
    i(l) {
      s || (d(e.$$.fragment, l), d(r.$$.fragment, l), d(o.$$.fragment, l), s = !0);
    },
    o(l) {
      p(e.$$.fragment, l), p(r.$$.fragment, l), p(o.$$.fragment, l), s = !1;
    },
    d(l) {
      l && (_(n), _(i)), $(e, l), $(r, l), $(o, l);
    }
  };
}
function $i(t) {
  let e, n;
  return e = new Te({
    props: {
      gutter: "32px",
      $$slots: { default: [vi] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p(r, [i]) {
      const o = {};
      i & /*$$scope, onContinue, closeButtonTitle, type, title, brandingInfo*/
      95 && (o.$$scope = { dirty: i, ctx: r }), e.$set(o);
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function ki(t, e, n) {
  let { $$slots: r = {}, $$scope: i } = e, { brandingInfo: o = null } = e, { onContinue: s } = e, { title: l } = e, { type: a } = e, { closeButtonTitle: c = "Go back to app" } = e;
  return t.$$set = (f) => {
    "brandingInfo" in f && n(0, o = f.brandingInfo), "onContinue" in f && n(1, s = f.onContinue), "title" in f && n(2, l = f.title), "type" in f && n(3, a = f.type), "closeButtonTitle" in f && n(4, c = f.closeButtonTitle), "$$scope" in f && n(6, i = f.$$scope);
  }, [o, s, l, a, c, r, i];
}
class on extends D {
  constructor(e) {
    super(), M(
      this,
      e,
      ki,
      $i,
      S,
      {
        brandingInfo: 0,
        onContinue: 1,
        title: 2,
        type: 3,
        closeButtonTitle: 4
      },
      gi
    );
  }
}
function At(t) {
  let e, n, r, i, o, s;
  return {
    c() {
      e = I("br"), n = H("If this error persists, please contact "), r = I("a"), i = H(
        /*supportEmail*/
        t[2]
      ), s = H("."), b(r, "href", o = "mailto:" + /*supportEmail*/
      t[2]);
    },
    m(l, a) {
      g(l, e, a), g(l, n, a), g(l, r, a), L(r, i), g(l, s, a);
    },
    p(l, a) {
      a & /*supportEmail*/
      4 && te(
        i,
        /*supportEmail*/
        l[2]
      ), a & /*supportEmail*/
      4 && o !== (o = "mailto:" + /*supportEmail*/
      l[2]) && b(r, "href", o);
    },
    d(l) {
      l && (_(e), _(n), _(r), _(s));
    }
  };
}
function Pi(t) {
  let e = (
    /*lastError*/
    t[1].getPublicErrorMessage(
      /*productDetails*/
      t[3]
    ) + ""
  ), n, r, i, o = (
    /*supportEmail*/
    t[2] && At(t)
  );
  return {
    c() {
      n = H(e), r = U(), o && o.c(), i = ee();
    },
    m(s, l) {
      g(s, n, l), g(s, r, l), o && o.m(s, l), g(s, i, l);
    },
    p(s, l) {
      l & /*lastError, productDetails*/
      10 && e !== (e = /*lastError*/
      s[1].getPublicErrorMessage(
        /*productDetails*/
        s[3]
      ) + "") && te(n, e), /*supportEmail*/
      s[2] ? o ? o.p(s, l) : (o = At(s), o.c(), o.m(i.parentNode, i)) : o && (o.d(1), o = null);
    },
    d(s) {
      s && (_(n), _(r), _(i)), o && o.d(s);
    }
  };
}
function Ti(t) {
  let e, n;
  return e = new Hr({ props: { slot: "icon" } }), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p: A,
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function Ai(t) {
  let e, n;
  return e = new on({
    props: {
      title: (
        /*getErrorTitle*/
        t[5]()
      ),
      brandingInfo: (
        /*brandingInfo*/
        t[0]
      ),
      onContinue: (
        /*onContinue*/
        t[4]
      ),
      type: "error",
      closeButtonTitle: "Try Again",
      $$slots: {
        icon: [Ti],
        default: [Pi]
      },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p(r, [i]) {
      const o = {};
      i & /*brandingInfo*/
      1 && (o.brandingInfo = /*brandingInfo*/
      r[0]), i & /*onContinue*/
      16 && (o.onContinue = /*onContinue*/
      r[4]), i & /*$$scope, supportEmail, lastError, productDetails*/
      78 && (o.$$scope = { dirty: i, ctx: r }), e.$set(o);
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function Oi(t, e, n) {
  let { brandingInfo: r = null } = e, { lastError: i } = e, { supportEmail: o = null } = e, { productDetails: s = null } = e, { onContinue: l } = e;
  Fe(() => {
    j.errorLog(`Displayed error: ${K[i.errorCode]}. Message: ${i.message ?? "None"}. Underlying error: ${i.underlyingErrorMessage ?? "None"}`);
  });
  function a() {
    switch (i.errorCode) {
      case K.AlreadyPurchasedError:
        return (s == null ? void 0 : s.productType) === Pe.Subscription ? "Already subscribed" : "Already purchased";
      default:
        return "Something went wrong";
    }
  }
  return t.$$set = (c) => {
    "brandingInfo" in c && n(0, r = c.brandingInfo), "lastError" in c && n(1, i = c.lastError), "supportEmail" in c && n(2, o = c.supportEmail), "productDetails" in c && n(3, s = c.productDetails), "onContinue" in c && n(4, l = c.onContinue);
  }, [
    r,
    i,
    o,
    s,
    l,
    a
  ];
}
class Ni extends D {
  constructor(e) {
    super(), M(this, e, Oi, Ai, S, {
      brandingInfo: 0,
      lastError: 1,
      supportEmail: 2,
      productDetails: 3,
      onContinue: 4
    });
  }
}
const Ui = `<svg width="96" height="96" viewBox="0 0 124 124" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <circle cx="62" cy="62" r="62" fill="currentColor"/>
    <rect x="44.1116" y="56" width="27.5" height="11" transform="rotate(45 44.1116 56)" fill="white"/>
    <rect x="79.1133" y="44.334" width="11" height="44" transform="rotate(45 79.1133 44.334)" fill="white"/>
</svg>
`;
function Ri(t) {
  F(t, "svelte-7wiquz", ".rcb-ui-asset-icon.svelte-7wiquz{width:96px;height:96px;margin:0 auto}");
}
function Li(t) {
  let e;
  return {
    c() {
      e = I("div"), ne(e, "color", "var(--rc-color-accent)"), b(e, "class", "rcb-ui-asset-icon svelte-7wiquz");
    },
    m(n, r) {
      g(n, e, r), e.innerHTML = Ui;
    },
    p: A,
    i: A,
    o: A,
    d(n) {
      n && _(e);
    }
  };
}
class Si extends D {
  constructor(e) {
    super(), M(this, e, null, Li, S, {}, Ri);
  }
}
function Mi(t) {
  let e;
  return {
    c() {
      e = H("Your plan is now active.");
    },
    m(n, r) {
      g(n, e, r);
    },
    d(n) {
      n && _(e);
    }
  };
}
function Di(t) {
  let e, n = (
    /*isSubscription*/
    t[2] && Mi()
  );
  return {
    c() {
      n && n.c(), e = ee();
    },
    m(r, i) {
      n && n.m(r, i), g(r, e, i);
    },
    p: A,
    d(r) {
      r && _(e), n && n.d(r);
    }
  };
}
function Bi(t) {
  let e, n;
  return e = new Si({ props: { slot: "icon" } }), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p: A,
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function Ci(t) {
  let e, n;
  return e = new on({
    props: {
      type: "success",
      title: "Purchase successful",
      brandingInfo: (
        /*brandingInfo*/
        t[0]
      ),
      onContinue: (
        /*onContinue*/
        t[1]
      ),
      closeButtonTitle: "Close",
      $$slots: {
        icon: [Bi],
        default: [Di]
      },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p(r, [i]) {
      const o = {};
      i & /*brandingInfo*/
      1 && (o.brandingInfo = /*brandingInfo*/
      r[0]), i & /*onContinue*/
      2 && (o.onContinue = /*onContinue*/
      r[1]), i & /*$$scope*/
      16 && (o.$$scope = { dirty: i, ctx: r }), e.$set(o);
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function Fi(t, e, n) {
  let { productDetails: r = null } = e, { brandingInfo: i = null } = e, { onContinue: o } = e;
  const s = (r == null ? void 0 : r.productType) === Pe.Subscription;
  return t.$$set = (l) => {
    "productDetails" in l && n(3, r = l.productDetails), "brandingInfo" in l && n(0, i = l.brandingInfo), "onContinue" in l && n(1, o = l.onContinue);
  }, [i, o, s, r];
}
class ji extends D {
  constructor(e) {
    super(), M(this, e, Fi, Ci, S, {
      productDetails: 3,
      brandingInfo: 0,
      onContinue: 1
    });
  }
}
function Hi(t, e, n, r, i = {}) {
  const o = n.create(e, i);
  return o.mount(t), o.on("change", (s) => r("change", s)), o.on("ready", (s) => r("ready", s)), o.on("focus", (s) => r("focus", s)), o.on("blur", (s) => r("blur", s)), o.on("escape", (s) => r("escape", s)), o.on("click", (s) => r("click", s)), o.on("loaderror", (s) => r("loaderror", s)), o.on("loaderstart", (s) => r("loaderstart", s)), o.on("networkschange", (s) => r("networkschange", s)), o;
}
const xi = typeof window > "u";
function qi(t) {
  if (!xi)
    return t.registerAppInfo({
      name: "svelte-stripe-js",
      url: "https://svelte-stripe-js.vercel.app"
    });
}
function Gi(t) {
  let e;
  return {
    c() {
      e = I("div");
    },
    m(n, r) {
      g(n, e, r), t[6](e);
    },
    p: A,
    i: A,
    o: A,
    d(n) {
      n && _(e), t[6](null);
    }
  };
}
function Vi(t, e, n) {
  let r, i;
  const o = zn(), { elements: s } = Kn("stripe");
  let { options: l = void 0 } = e;
  Fe(() => (r = Hi(i, "payment", s, o, l), () => r.destroy()));
  function a() {
    r.blur();
  }
  function c() {
    r.clear();
  }
  function f() {
    r.destroy();
  }
  function u() {
    r.focus();
  }
  function m(h) {
    De[h ? "unshift" : "push"](() => {
      i = h, n(0, i);
    });
  }
  return t.$$set = (h) => {
    "options" in h && n(1, l = h.options);
  }, [i, l, a, c, f, u, m];
}
class Yi extends D {
  constructor(e) {
    super(), M(this, e, Vi, Gi, S, {
      options: 1,
      blur: 2,
      clear: 3,
      destroy: 4,
      focus: 5
    });
  }
  get blur() {
    return this.$$.ctx[2];
  }
  get clear() {
    return this.$$.ctx[3];
  }
  get destroy() {
    return this.$$.ctx[4];
  }
  get focus() {
    return this.$$.ctx[5];
  }
}
function Ot(t) {
  let e;
  const n = (
    /*#slots*/
    t[15].default
  ), r = q(
    n,
    t,
    /*$$scope*/
    t[14],
    null
  );
  return {
    c() {
      r && r.c();
    },
    m(i, o) {
      r && r.m(i, o), e = !0;
    },
    p(i, o) {
      r && r.p && (!e || o & /*$$scope*/
      16384) && V(
        r,
        n,
        i,
        /*$$scope*/
        i[14],
        e ? G(
          n,
          /*$$scope*/
          i[14],
          o,
          null
        ) : Y(
          /*$$scope*/
          i[14]
        ),
        null
      );
    },
    i(i) {
      e || (d(r, i), e = !0);
    },
    o(i) {
      p(r, i), e = !1;
    },
    d(i) {
      r && r.d(i);
    }
  };
}
function zi(t) {
  let e, n, r = (
    /*stripe*/
    t[1] && /*elements*/
    t[0] && Ot(t)
  );
  return {
    c() {
      r && r.c(), e = ee();
    },
    m(i, o) {
      r && r.m(i, o), g(i, e, o), n = !0;
    },
    p(i, [o]) {
      /*stripe*/
      i[1] && /*elements*/
      i[0] ? r ? (r.p(i, o), o & /*stripe, elements*/
      3 && d(r, 1)) : (r = Ot(i), r.c(), d(r, 1), r.m(e.parentNode, e)) : r && (z(), p(r, 1, 1, () => {
        r = null;
      }), W());
    },
    i(i) {
      n || (d(r), n = !0);
    },
    o(i) {
      p(r), n = !1;
    },
    d(i) {
      i && _(e), r && r.d(i);
    }
  };
}
function Wi(t, e, n) {
  let r, { $$slots: i = {}, $$scope: o } = e, { stripe: s } = e, { mode: l = void 0 } = e, { theme: a = "stripe" } = e, { variables: c = {} } = e, { rules: f = {} } = e, { labels: u = "above" } = e, { loader: m = "auto" } = e, { fonts: h = [] } = e, { locale: y = "auto" } = e, { currency: T = void 0 } = e, { amount: w = void 0 } = e, { clientSecret: O = void 0 } = e, { elements: C = null } = e;
  return t.$$set = (E) => {
    "stripe" in E && n(1, s = E.stripe), "mode" in E && n(2, l = E.mode), "theme" in E && n(3, a = E.theme), "variables" in E && n(4, c = E.variables), "rules" in E && n(5, f = E.rules), "labels" in E && n(6, u = E.labels), "loader" in E && n(7, m = E.loader), "fonts" in E && n(8, h = E.fonts), "locale" in E && n(9, y = E.locale), "currency" in E && n(10, T = E.currency), "amount" in E && n(11, w = E.amount), "clientSecret" in E && n(12, O = E.clientSecret), "elements" in E && n(0, C = E.elements), "$$scope" in E && n(14, o = E.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty & /*theme, variables, rules, labels*/
    120 && n(13, r = { theme: a, variables: c, rules: f, labels: u }), t.$$.dirty & /*stripe, elements, mode, currency, amount, appearance, clientSecret, fonts, loader, locale*/
    16263 && s && !C && (n(0, C = s.elements({
      mode: l,
      currency: T,
      amount: w,
      appearance: r,
      clientSecret: O,
      fonts: h,
      loader: m,
      locale: y
    })), qi(s), Wn("stripe", { stripe: s, elements: C })), t.$$.dirty & /*elements, appearance, locale*/
    8705 && C && C.update({ appearance: r, locale: y });
  }, [
    C,
    s,
    l,
    a,
    c,
    f,
    u,
    m,
    h,
    y,
    T,
    w,
    O,
    r,
    o,
    i
  ];
}
class Ki extends D {
  constructor(e) {
    super(), M(this, e, Wi, zi, S, {
      stripe: 1,
      mode: 2,
      theme: 3,
      variables: 4,
      rules: 5,
      labels: 6,
      loader: 7,
      fonts: 8,
      locale: 9,
      currency: 10,
      amount: 11,
      clientSecret: 12,
      elements: 0
    });
  }
}
var sn = "https://js.stripe.com/v3", Qi = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/, Nt = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used", Xi = function() {
  for (var e = document.querySelectorAll('script[src^="'.concat(sn, '"]')), n = 0; n < e.length; n++) {
    var r = e[n];
    if (Qi.test(r.src))
      return r;
  }
  return null;
}, Ut = function(e) {
  var n = "", r = document.createElement("script");
  r.src = "".concat(sn).concat(n);
  var i = document.head || document.body;
  if (!i)
    throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
  return i.appendChild(r), r;
}, Zi = function(e, n) {
  !e || !e._registerWrapper || e._registerWrapper({
    name: "stripe-js",
    version: "2.4.0",
    startTime: n
  });
}, ge = null, Re = null, Le = null, Ji = function(e) {
  return function() {
    e(new Error("Failed to load Stripe.js"));
  };
}, eo = function(e, n) {
  return function() {
    window.Stripe ? e(window.Stripe) : n(new Error("Stripe.js not available"));
  };
}, to = function(e) {
  return ge !== null ? ge : (ge = new Promise(function(n, r) {
    if (typeof window > "u" || typeof document > "u") {
      n(null);
      return;
    }
    if (window.Stripe && e && console.warn(Nt), window.Stripe) {
      n(window.Stripe);
      return;
    }
    try {
      var i = Xi();
      if (i && e)
        console.warn(Nt);
      else if (!i)
        i = Ut(e);
      else if (i && Le !== null && Re !== null) {
        var o;
        i.removeEventListener("load", Le), i.removeEventListener("error", Re), (o = i.parentNode) === null || o === void 0 || o.removeChild(i), i = Ut(e);
      }
      Le = eo(n, r), Re = Ji(r), i.addEventListener("load", Le), i.addEventListener("error", Re);
    } catch (s) {
      r(s);
      return;
    }
  }), ge.catch(function(n) {
    return ge = null, Promise.reject(n);
  }));
}, no = function(e, n, r) {
  if (e === null)
    return null;
  var i = e.apply(void 0, n);
  return Zi(i, r), i;
}, he, ln = !1, an = function() {
  return he || (he = to(null).catch(function(e) {
    return he = null, Promise.reject(e);
  }), he);
};
Promise.resolve().then(function() {
  return an();
}).catch(function(t) {
  ln || console.warn(t);
});
var ro = function() {
  for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
    n[r] = arguments[r];
  ln = !0;
  var i = Date.now();
  return an().then(function(o) {
    return no(o, n, i);
  });
};
function io(t) {
  F(t, "svelte-1xe711j", ".rcb-header-layout.svelte-1xe711j{display:flex;justify-content:space-between;align-items:center;width:100%;font-size:24px;margin:0;font-weight:500}");
}
function oo(t) {
  let e, n;
  const r = (
    /*#slots*/
    t[0].default
  ), i = q(
    r,
    t,
    /*$$scope*/
    t[1],
    null
  );
  return {
    c() {
      e = I("div"), i && i.c(), b(e, "class", "rcb-header-layout svelte-1xe711j");
    },
    m(o, s) {
      g(o, e, s), i && i.m(e, null), n = !0;
    },
    p(o, s) {
      i && i.p && (!n || s & /*$$scope*/
      2) && V(
        i,
        r,
        o,
        /*$$scope*/
        o[1],
        n ? G(
          r,
          /*$$scope*/
          o[1],
          s,
          null
        ) : Y(
          /*$$scope*/
          o[1]
        ),
        null
      );
    },
    i(o) {
      n || (d(i, o), n = !0);
    },
    o(o) {
      p(i, o), n = !1;
    },
    d(o) {
      o && _(e), i && i.d(o);
    }
  };
}
function so(t) {
  let e, n;
  return e = new de({
    props: {
      as: "header",
      $$slots: { default: [oo] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p(r, [i]) {
      const o = {};
      i & /*$$scope*/
      2 && (o.$$scope = { dirty: i, ctx: r }), e.$set(o);
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function lo(t, e, n) {
  let { $$slots: r = {}, $$scope: i } = e;
  return t.$$set = (o) => {
    "$$scope" in o && n(1, i = o.$$scope);
  }, [r, i];
}
class ot extends D {
  constructor(e) {
    super(), M(this, e, lo, so, S, {}, io);
  }
}
const ao = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
     xmlns="http://www.w3.org/2000/svg">
    <path d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17ZM15.1 8H8.9V6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8Z"
          fill="currentColor"/>
</svg>
`;
function co(t) {
  F(t, "svelte-1z0jca3", "div.svelte-1z0jca3{height:24px;width:24px}");
}
function uo(t) {
  let e;
  return {
    c() {
      e = I("div"), ne(e, "color", "var(--rc-color-accent)"), b(e, "class", "rcb-ui-asset-icon svelte-1z0jca3");
    },
    m(n, r) {
      g(n, e, r), e.innerHTML = ao;
    },
    p: A,
    i: A,
    o: A,
    d(n) {
      n && _(e);
    }
  };
}
class fo extends D {
  constructor(e) {
    super(), M(this, e, null, uo, S, {}, co);
  }
}
function po(t) {
  F(t, "svelte-rjmul6", `.processing.svelte-rjmul6{width:12px;aspect-ratio:1;border-radius:50%;animation:svelte-rjmul6-l5 1.5s infinite linear}@keyframes svelte-rjmul6-l5{0%{box-shadow:20px 0 #fff2,
        -20px 0 #fff2;background:#fff2}25%{box-shadow:20px 0 #fff2,
        -20px 0 #ffff;background:#fff2}50%{box-shadow:20px 0 #fff2,
        -20px 0 #fff2;background:#ffff}75%{box-shadow:20px 0 #ffff,
        -20px 0 #fff2;background:#fff2}100%{box-shadow:20px 0 #fff2,
        -20px 0 #fff2;background:#fff2}}`);
}
function mo(t) {
  let e;
  return {
    c() {
      e = I("div"), b(e, "class", "processing svelte-rjmul6");
    },
    m(n, r) {
      g(n, e, r);
    },
    p: A,
    i: A,
    o: A,
    d(n) {
      n && _(e);
    }
  };
}
class cn extends D {
  constructor(e) {
    super(), M(this, e, null, mo, S, {}, po);
  }
}
const _o = {
  error: "#f2545b",
  warning: "#f4e971",
  focus: "#000080",
  accent: "#7676767",
  primary: "#000000",
  "primary-text": "#ffffff",
  white: "#ffffff",
  "grey-text-dark": "rgba(0,0,0,1)",
  "grey-text-light": "rgba(0,0,0,0.5)",
  "grey-ui-dark": "rgba(0,0,0,0.125)",
  "grey-ui-light": "rgba(0,0,0,0.005)",
  "input-background": "transparent",
  background: "white"
}, go = {
  error: "#f2545b",
  warning: "#f4e971",
  focus: "#000080",
  accent: "#7676767",
  primary: "#ffffff",
  "primary-text": "#000000",
  white: "#ffffff",
  "grey-text-dark": "rgba(255,255,255,1)",
  "grey-text-light": "rgba(255,255,255,0.5)",
  "grey-ui-dark": "rgba(255,255,255,0.125)",
  "grey-ui-light": "rgba(255,255,255,0.005)",
  "input-background": "transparent",
  background: "#000000"
}, un = {
  error: "color_error",
  focus: "color_accent",
  accent: "color_accent",
  primary: "color_buttons_primary"
}, ho = {
  ...un,
  background: "color_form_bg"
}, bo = {
  ...un,
  background: "color_product_info_bg"
}, fn = {
  "input-border-radius": "12px",
  "input-button-border-radius": "12px",
  "modal-border-radius": "16px"
}, wo = {
  "input-border-radius": "0px",
  "input-button-border-radius": "0px",
  "modal-border-radius": "0px"
}, yo = {
  "input-border-radius": "24px",
  "input-button-border-radius": "56px",
  "modal-border-radius": "16px"
}, Rt = fn, Lt = (t) => t.length == 7 ? {
  r: parseInt(t.slice(1, 3), 16),
  g: parseInt(t.slice(3, 5), 16),
  b: parseInt(t.slice(5, 7), 16)
} : t.length == 4 ? {
  r: parseInt(t[1], 16),
  g: parseInt(t[2], 16),
  b: parseInt(t[3], 16)
} : null, dn = ({ r: t, g: e, b: n }) => {
  const r = (o) => (o = o / 255, o <= 0.03928 ? o / 12.92 : Math.pow((o + 0.055) / 1.055, 2.4));
  return 0.2126 * r(t) + 0.7152 * r(e) + 0.0722 * r(n) > 0.179;
}, Eo = (t) => {
  const e = dn(t) ? "0,0,0" : "255,255,255";
  return {
    "grey-text-dark": `rgba(${e},1.0)`,
    "grey-text-light": `rgba(${e},0.50)`,
    "grey-ui-dark": `rgba(${e},0.125)`,
    "grey-ui-light": `rgba(${e},0.05)`
  };
}, Io = (t, e, n) => {
  const r = {
    "grey-text-dark": n["grey-text-dark"],
    "grey-text-light": n["grey-text-light"],
    "grey-ui-dark": n["grey-ui-dark"],
    "grey-ui-light": n["grey-ui-light"],
    "primary-text": n["primary-text"]
  };
  if (t != null && t.startsWith("#")) {
    const i = Lt(t);
    i !== null && Object.assign(r, Eo(i));
  }
  if (e != null && e.startsWith("#")) {
    const i = Lt(e);
    i !== null && (r["primary-text"] = dn(i) ? "black" : "white");
  }
  return r;
}, vo = (t, e) => t || e, $o = (t, e, n) => {
  const r = Object.entries(t).map(([i, o]) => [
    i,
    vo(
      n ? n[o] : null,
      e[i]
    )
  ]);
  return Object.fromEntries(r);
}, pn = (t, e, n) => {
  const r = $o(
    t,
    e,
    n
  );
  return n ? {
    ...e,
    ...r,
    ...Io(
      r.background,
      r.primary,
      e
    )
  } : { ...e };
}, ko = (t) => pn(
  bo,
  go,
  t
), mn = (t) => pn(
  ho,
  _o,
  t
), st = (t) => {
  if (!t)
    return Rt;
  switch (t.shapes) {
    case "rounded":
      return fn;
    case "rectangle":
      return wo;
    case "pill":
      return yo;
    default:
      return Rt;
  }
}, Be = (t = "", e) => e.map(([n, r]) => `--rc-${t}-${n}: ${r}`).join("; "), _n = (t) => {
  const e = Be(
    "color",
    Object.entries(ko(t))
  ), n = Be(
    "shape",
    Object.entries(st(t))
  );
  return [e, n].join("; ");
}, Po = (t) => {
  const e = Be(
    "color",
    Object.entries(mn(t))
  ), n = Be(
    "shape",
    Object.entries(st(t))
  );
  return [e, n].join("; ");
};
class lt {
  constructor(e) {
    this.brandingAppearance = e;
  }
  get shape() {
    return st(this.brandingAppearance);
  }
  get formColors() {
    return mn(this.brandingAppearance);
  }
  get formStyleVars() {
    return Po(this.brandingAppearance);
  }
  get productInfoStyleVars() {
    return _n(this.brandingAppearance);
  }
}
function To(t) {
  F(t, "svelte-8jsoa8", ".rcb-stripe-elements-container.svelte-8jsoa8{width:100%;min-height:320px;margin-top:32px;margin-bottom:24px}");
}
function Ao(t) {
  let e, n;
  return e = new tt({}), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p: A,
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function Oo(t) {
  let e, n, r, i, o, s, l, a;
  e = new ot({
    props: {
      $$slots: { default: [No] },
      $$scope: { ctx: t }
    }
  });
  function c(u) {
    t[14](u);
  }
  let f = {
    stripe: (
      /*stripe*/
      t[5]
    ),
    clientSecret: (
      /*clientSecret*/
      t[6]
    ),
    loader: "always",
    locale: "en",
    theme: "stripe",
    variables: {
      borderRadius: (
        /*shapeCustomisation*/
        t[8]["input-border-radius"]
      ),
      fontSizeBase: "16px",
      fontSizeSm: "16px",
      spacingGridRow: "16px",
      focusBoxShadow: "none",
      colorDanger: (
        /*customColors*/
        t[9].error
      ),
      colorTextPlaceholder: (
        /*customColors*/
        t[9]["grey-text-light"]
      )
    },
    rules: {
      ".Input": {
        boxShadow: "none",
        border: `2px solid ${/*customColors*/
        t[9]["grey-ui-dark"]}`,
        backgroundColor: "transparent",
        color: (
          /*customColors*/
          t[9]["grey-text-dark"]
        )
      },
      ".Input:focus": {
        border: `2px solid ${/*customColors*/
        t[9].focus}`,
        outline: "none"
      },
      ".Label": {
        marginBottom: "8px",
        fontWeight: "500",
        lineHeight: "22px",
        color: (
          /*customColors*/
          t[9]["grey-text-dark"]
        )
      },
      ".Input--invalid": { boxShadow: "none" },
      ".Tab": {
        boxShadow: "none",
        backgroundColor: "transparent"
      }
    },
    $$slots: { default: [Co] },
    $$scope: { ctx: t }
  };
  return (
    /*elements*/
    t[4] !== void 0 && (f.elements = /*elements*/
    t[4]), i = new Ki({ props: f }), De.push(() => tr(i, "elements", c)), {
      c() {
        k(e.$$.fragment), n = U(), r = I("form"), k(i.$$.fragment);
      },
      m(u, m) {
        v(e, u, m), g(u, n, m), g(u, r, m), v(i, r, null), s = !0, l || (a = $e(r, "submit", Qt(
          /*handleContinue*/
          t[7]
        )), l = !0);
      },
      p(u, m) {
        const h = {};
        m & /*$$scope, onClose*/
        131074 && (h.$$scope = { dirty: m, ctx: u }), e.$set(h);
        const y = {};
        m & /*stripe*/
        32 && (y.stripe = /*stripe*/
        u[5]), m & /*$$scope, processing, productDetails, purchaseOptionToUse*/
        131085 && (y.$$scope = { dirty: m, ctx: u }), !o && m & /*elements*/
        16 && (o = !0, y.elements = /*elements*/
        u[4], Zn(() => o = !1)), i.$set(y);
      },
      i(u) {
        s || (d(e.$$.fragment, u), d(i.$$.fragment, u), s = !0);
      },
      o(u) {
        p(e.$$.fragment, u), p(i.$$.fragment, u), s = !1;
      },
      d(u) {
        u && (_(n), _(r)), $(e, u), $(i), l = !1, a();
      }
    }
  );
}
function No(t) {
  let e, n, r, i, o, s, l;
  return n = new fo({}), s = new it({}), s.$on("click", function() {
    fe(
      /*onClose*/
      t[1]
    ) && t[1].apply(this, arguments);
  }), {
    c() {
      e = I("div"), k(n.$$.fragment), r = U(), i = I("div"), i.textContent = "Secure Checkout", o = U(), k(s.$$.fragment), ne(i, "margin-left", "10px"), ne(e, "display", "flex"), ne(e, "align-items", "center"), ne(e, "justify-content", "baseline");
    },
    m(a, c) {
      g(a, e, c), v(n, e, null), L(e, r), L(e, i), g(a, o, c), v(s, a, c), l = !0;
    },
    p(a, c) {
      t = a;
    },
    i(a) {
      l || (d(n.$$.fragment, a), d(s.$$.fragment, a), l = !0);
    },
    o(a) {
      p(n.$$.fragment, a), p(s.$$.fragment, a), l = !1;
    },
    d(a) {
      a && (_(e), _(o)), $(n), $(s, a);
    }
  };
}
function Uo(t) {
  let e, n, r;
  return n = new Yi({}), {
    c() {
      e = I("div"), k(n.$$.fragment), b(e, "class", "rcb-stripe-elements-container svelte-8jsoa8");
    },
    m(i, o) {
      g(i, e, o), v(n, e, null), r = !0;
    },
    p: A,
    i(i) {
      r || (d(n.$$.fragment, i), r = !0);
    },
    o(i) {
      p(n.$$.fragment, i), r = !1;
    },
    d(i) {
      i && _(e), $(n);
    }
  };
}
function Ro(t) {
  let e;
  return {
    c() {
      e = H("Pay");
    },
    m(n, r) {
      g(n, e, r);
    },
    i: A,
    o: A,
    d(n) {
      n && _(e);
    }
  };
}
function Lo(t) {
  let e;
  return {
    c() {
      e = H("Start Trial");
    },
    m(n, r) {
      g(n, e, r);
    },
    i: A,
    o: A,
    d(n) {
      n && _(e);
    }
  };
}
function So(t) {
  let e, n;
  return e = new cn({}), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function Mo(t) {
  let e, n, r, i;
  const o = [So, Lo, Ro], s = [];
  function l(a, c) {
    var f, u;
    return (
      /*processing*/
      a[0] ? 0 : (
        /*productDetails*/
        (u = (f = a[2].subscriptionOptions) == null ? void 0 : f[
          /*purchaseOptionToUse*/
          a[3].id
        ]) != null && u.trial ? 1 : 2
      )
    );
  }
  return e = l(t), n = s[e] = o[e](t), {
    c() {
      n.c(), r = ee();
    },
    m(a, c) {
      s[e].m(a, c), g(a, r, c), i = !0;
    },
    p(a, c) {
      let f = e;
      e = l(a), e !== f && (z(), p(s[f], 1, 1, () => {
        s[f] = null;
      }), W(), n = s[e], n || (n = s[e] = o[e](a), n.c()), d(n, 1), n.m(r.parentNode, r));
    },
    i(a) {
      i || (d(n), i = !0);
    },
    o(a) {
      p(n), i = !1;
    },
    d(a) {
      a && _(r), s[e].d(a);
    }
  };
}
function Do(t) {
  let e, n;
  return e = new nt({
    props: {
      disabled: (
        /*processing*/
        t[0]
      ),
      testId: "PayButton",
      $$slots: { default: [Mo] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p(r, i) {
      const o = {};
      i & /*processing*/
      1 && (o.disabled = /*processing*/
      r[0]), i & /*$$scope, processing, productDetails, purchaseOptionToUse*/
      131085 && (o.$$scope = { dirty: i, ctx: r }), e.$set(o);
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function Bo(t) {
  let e, n;
  return e = new Te({
    props: {
      $$slots: { default: [Do] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p(r, i) {
      const o = {};
      i & /*$$scope, processing, productDetails, purchaseOptionToUse*/
      131085 && (o.$$scope = { dirty: i, ctx: r }), e.$set(o);
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function Co(t) {
  let e, n, r, i;
  return e = new de({
    props: {
      $$slots: { default: [Uo] },
      $$scope: { ctx: t }
    }
  }), r = new rt({
    props: {
      $$slots: { default: [Bo] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      k(e.$$.fragment), n = U(), k(r.$$.fragment);
    },
    m(o, s) {
      v(e, o, s), g(o, n, s), v(r, o, s), i = !0;
    },
    p(o, s) {
      const l = {};
      s & /*$$scope*/
      131072 && (l.$$scope = { dirty: s, ctx: o }), e.$set(l);
      const a = {};
      s & /*$$scope, processing, productDetails, purchaseOptionToUse*/
      131085 && (a.$$scope = { dirty: s, ctx: o }), r.$set(a);
    },
    i(o) {
      i || (d(e.$$.fragment, o), d(r.$$.fragment, o), i = !0);
    },
    o(o) {
      p(e.$$.fragment, o), p(r.$$.fragment, o), i = !1;
    },
    d(o) {
      o && _(n), $(e, o), $(r, o);
    }
  };
}
function Fo(t) {
  let e, n, r, i;
  const o = [Oo, Ao], s = [];
  function l(a, c) {
    return (
      /*stripe*/
      a[5] && /*clientSecret*/
      a[6] ? 0 : 1
    );
  }
  return n = l(t), r = s[n] = o[n](t), {
    c() {
      e = I("div"), r.c();
    },
    m(a, c) {
      g(a, e, c), s[n].m(e, null), i = !0;
    },
    p(a, [c]) {
      let f = n;
      n = l(a), n === f ? s[n].p(a, c) : (z(), p(s[f], 1, 1, () => {
        s[f] = null;
      }), W(), r = s[n], r ? r.p(a, c) : (r = s[n] = o[n](a), r.c()), d(r, 1), r.m(e, null));
    },
    i(a) {
      i || (d(r), i = !0);
    },
    o(a) {
      p(r), i = !1;
    },
    d(a) {
      a && _(e), s[n].d();
    }
  };
}
function jo(t, e, n) {
  let { onClose: r } = e, { onContinue: i } = e, { onError: o } = e, { paymentInfoCollectionMetadata: s } = e, { processing: l = !1 } = e, { productDetails: a } = e, { purchaseOptionToUse: c } = e, { brandingInfo: f } = e;
  const u = s.data.client_secret;
  let m = null, h, y;
  Fe(async () => {
    const P = s.data.publishable_api_key, B = s.data.stripe_account_id;
    if (!P || !B)
      throw new Error("Stripe publishable key or account ID not found");
    n(5, m = await ro(P, { stripeAccount: B }));
  });
  const T = async () => {
    if (l || !m || !y) return;
    n(0, l = !0);
    const P = await m.confirmSetup({
      elements: y,
      redirect: "if_required"
    });
    P.error ? (n(0, l = !1), o(new x(K.StripeError, P.error.message))) : i();
  }, w = new lt(f == null ? void 0 : f.appearance);
  let O = w.shape, C = w.formColors;
  function E(P) {
    h = P, n(4, h);
  }
  return t.$$set = (P) => {
    "onClose" in P && n(1, r = P.onClose), "onContinue" in P && n(10, i = P.onContinue), "onError" in P && n(11, o = P.onError), "paymentInfoCollectionMetadata" in P && n(12, s = P.paymentInfoCollectionMetadata), "processing" in P && n(0, l = P.processing), "productDetails" in P && n(2, a = P.productDetails), "purchaseOptionToUse" in P && n(3, c = P.purchaseOptionToUse), "brandingInfo" in P && n(13, f = P.brandingInfo);
  }, t.$$.update = () => {
    t.$$.dirty & /*elements*/
    16 && h && h._elements.length > 0 && (y = h);
  }, [
    l,
    r,
    a,
    c,
    h,
    m,
    u,
    T,
    O,
    C,
    i,
    o,
    s,
    f,
    E
  ];
}
class Ho extends D {
  constructor(e) {
    super(), M(
      this,
      e,
      jo,
      Fo,
      S,
      {
        onClose: 1,
        onContinue: 10,
        onError: 11,
        paymentInfoCollectionMetadata: 12,
        processing: 0,
        productDetails: 2,
        purchaseOptionToUse: 3,
        brandingInfo: 13
      },
      To
    );
  }
}
function xo(t) {
  return t.trim() === "" ? "You need to provide your email address to continue." : t.match(/^[^@]+@[^@]+\.[^@]+$/) ? null : "Email is not valid. Please provide a valid email address.";
}
function qo(t) {
  if (t && !t.match(/^[A-Z]{3}$/)) {
    const e = `Currency code ${t} is not valid. Please provide a valid ISO 4217 currency code.`;
    throw j.errorLog(e), new Q(X.ConfigurationError, e);
  }
}
function Go(t) {
  F(t, "svelte-yf01ty", ".container.svelte-yf01ty.svelte-yf01ty{display:flex;flex-direction:column;flex-grow:1}form.svelte-yf01ty.svelte-yf01ty{display:flex;flex-direction:column;min-height:100%;flex-grow:1}.form-container.svelte-yf01ty.svelte-yf01ty{display:flex;flex-direction:column;width:100%;margin-top:32px;margin-bottom:16px}.form-label.svelte-yf01ty.svelte-yf01ty{margin-top:8px;margin-bottom:8px;display:block;font-weight:500;line-height:22px}.form-input.error.svelte-yf01ty input.svelte-yf01ty{border-color:var(--rc-color-error)}.form-error.svelte-yf01ty.svelte-yf01ty{margin-top:4px;font-size:16px;line-height:20px;min-height:40px;color:var(--rc-color-error)}input.svelte-yf01ty.svelte-yf01ty{width:100%;box-sizing:border-box;padding:8px;border:2px solid var(--rc-color-grey-ui-dark);border-radius:var(--rc-shape-input-border-radius);font-size:16px;height:48px;padding:6px 14px;background:var(--rc-color-input-background);color:inherit}input.svelte-yf01ty.svelte-yf01ty:focus{outline:none;border:2px solid var(--rc-color-focus)}");
}
function Vo(t) {
  let e, n, r, i;
  return r = new it({}), r.$on("click", function() {
    fe(
      /*onClose*/
      t[0]
    ) && t[0].apply(this, arguments);
  }), {
    c() {
      e = I("span"), e.textContent = "Billing email address", n = U(), k(r.$$.fragment);
    },
    m(o, s) {
      g(o, e, s), g(o, n, s), v(r, o, s), i = !0;
    },
    p(o, s) {
      t = o;
    },
    i(o) {
      i || (d(r.$$.fragment, o), i = !0);
    },
    o(o) {
      p(r.$$.fragment, o), i = !1;
    },
    d(o) {
      o && (_(e), _(n)), $(r, o);
    }
  };
}
function St(t) {
  let e, n;
  return {
    c() {
      e = I("div"), n = H(
        /*error*/
        t[2]
      ), b(e, "class", "form-error svelte-yf01ty");
    },
    m(r, i) {
      g(r, e, i), L(e, n);
    },
    p(r, i) {
      i & /*error*/
      4 && te(
        n,
        /*error*/
        r[2]
      );
    },
    d(r) {
      r && _(e);
    }
  };
}
function Yo(t) {
  let e, n, r, i, o, s, l, a, c, f = (
    /*error*/
    t[2] && St(t)
  );
  return {
    c() {
      e = I("div"), n = I("div"), n.innerHTML = '<label for="email">Email</label>', r = U(), i = I("div"), o = I("input"), l = U(), f && f.c(), b(n, "class", "form-label svelte-yf01ty"), b(o, "name", "email"), b(o, "placeholder", "john@appleseed.com"), b(o, "autocapitalize", "off"), b(o, "class", "svelte-yf01ty"), b(i, "class", s = "form-input " + /*inputClass*/
      t[4] + " svelte-yf01ty"), b(e, "class", "form-container svelte-yf01ty");
    },
    m(u, m) {
      g(u, e, m), L(e, n), L(e, r), L(e, i), L(i, o), yt(
        o,
        /*email*/
        t[3]
      ), L(e, l), f && f.m(e, null), a || (c = $e(
        o,
        "input",
        /*input_input_handler*/
        t[8]
      ), a = !0);
    },
    p(u, m) {
      m & /*email*/
      8 && o.value !== /*email*/
      u[3] && yt(
        o,
        /*email*/
        u[3]
      ), m & /*inputClass*/
      16 && s !== (s = "form-input " + /*inputClass*/
      u[4] + " svelte-yf01ty") && b(i, "class", s), /*error*/
      u[2] ? f ? f.p(u, m) : (f = St(u), f.c(), f.m(e, null)) : f && (f.d(1), f = null);
    },
    d(u) {
      u && _(e), f && f.d(), a = !1, c();
    }
  };
}
function zo(t) {
  let e;
  return {
    c() {
      e = H("Continue");
    },
    m(n, r) {
      g(n, e, r);
    },
    i: A,
    o: A,
    d(n) {
      n && _(e);
    }
  };
}
function Wo(t) {
  let e, n;
  return e = new cn({}), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function Ko(t) {
  let e, n, r, i;
  const o = [Wo, zo], s = [];
  function l(a, c) {
    return (
      /*processing*/
      a[1] ? 0 : 1
    );
  }
  return e = l(t), n = s[e] = o[e](t), {
    c() {
      n.c(), r = ee();
    },
    m(a, c) {
      s[e].m(a, c), g(a, r, c), i = !0;
    },
    p(a, c) {
      let f = e;
      e = l(a), e !== f && (z(), p(s[f], 1, 1, () => {
        s[f] = null;
      }), W(), n = s[e], n || (n = s[e] = o[e](a), n.c()), d(n, 1), n.m(r.parentNode, r));
    },
    i(a) {
      i || (d(n), i = !0);
    },
    o(a) {
      p(n), i = !1;
    },
    d(a) {
      a && _(r), s[e].d(a);
    }
  };
}
function Qo(t) {
  let e, n;
  return e = new nt({
    props: {
      disabled: (
        /*processing*/
        t[1]
      ),
      type: "submit",
      $$slots: { default: [Ko] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p(r, i) {
      const o = {};
      i & /*processing*/
      2 && (o.disabled = /*processing*/
      r[1]), i & /*$$scope, processing*/
      514 && (o.$$scope = { dirty: i, ctx: r }), e.$set(o);
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function Xo(t) {
  let e, n;
  return e = new Te({
    props: {
      $$slots: { default: [Qo] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p(r, i) {
      const o = {};
      i & /*$$scope, processing*/
      514 && (o.$$scope = { dirty: i, ctx: r }), e.$set(o);
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function Zo(t) {
  let e, n, r, i, o, s, l, a, c, f;
  return n = new ot({
    props: {
      $$slots: { default: [Vo] },
      $$scope: { ctx: t }
    }
  }), o = new de({
    props: {
      $$slots: { default: [Yo] },
      $$scope: { ctx: t }
    }
  }), l = new rt({
    props: {
      $$slots: { default: [Xo] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      e = I("div"), k(n.$$.fragment), r = U(), i = I("form"), k(o.$$.fragment), s = U(), k(l.$$.fragment), b(i, "class", "svelte-yf01ty"), b(e, "class", "container svelte-yf01ty");
    },
    m(u, m) {
      g(u, e, m), v(n, e, null), L(e, r), L(e, i), v(o, i, null), L(i, s), v(l, i, null), a = !0, c || (f = $e(i, "submit", Qt(
        /*handleContinue*/
        t[5]
      )), c = !0);
    },
    p(u, [m]) {
      const h = {};
      m & /*$$scope, onClose*/
      513 && (h.$$scope = { dirty: m, ctx: u }), n.$set(h);
      const y = {};
      m & /*$$scope, error, inputClass, email*/
      540 && (y.$$scope = { dirty: m, ctx: u }), o.$set(y);
      const T = {};
      m & /*$$scope, processing*/
      514 && (T.$$scope = { dirty: m, ctx: u }), l.$set(T);
    },
    i(u) {
      a || (d(n.$$.fragment, u), d(o.$$.fragment, u), d(l.$$.fragment, u), a = !0);
    },
    o(u) {
      p(n.$$.fragment, u), p(o.$$.fragment, u), p(l.$$.fragment, u), a = !1;
    },
    d(u) {
      u && _(e), $(n), $(o), $(l), c = !1, f();
    }
  };
}
function Jo(t, e, n) {
  let r, i, o, { onContinue: s } = e, { onClose: l } = e, { processing: a } = e, { lastError: c } = e;
  const f = async () => {
    const m = xo(r);
    m ? n(2, i = m) : s({ email: r });
  };
  Yn(async () => {
    n(2, i = (c == null ? void 0 : c.message) ?? "");
  });
  function u() {
    r = this.value, n(3, r);
  }
  return t.$$set = (m) => {
    "onContinue" in m && n(6, s = m.onContinue), "onClose" in m && n(0, l = m.onClose), "processing" in m && n(1, a = m.processing), "lastError" in m && n(7, c = m.lastError);
  }, t.$$.update = () => {
    t.$$.dirty & /*error*/
    4 && n(4, o = i ? "error" : "");
  }, n(3, r = ""), n(2, i = ""), [
    l,
    a,
    i,
    r,
    o,
    f,
    s,
    c,
    u
  ];
}
class es extends D {
  constructor(e) {
    super(), M(
      this,
      e,
      Jo,
      Zo,
      S,
      {
        onContinue: 6,
        onClose: 0,
        processing: 1,
        lastError: 7
      },
      Go
    );
  }
}
function ts(t) {
  F(t, "svelte-17tslso", ".rcb-modal-backdrop.svelte-17tslso{position:fixed;top:0;left:0;right:0;min-width:100%;width:100vw;width:100dvw;min-height:100%;height:100vh;height:100dvh;background-color:rgba(40, 40, 40, 0.75);display:flex;flex-direction:column;justify-content:space-around;z-index:1000001}");
}
function ns(t) {
  let e, n;
  const r = (
    /*#slots*/
    t[1].default
  ), i = q(
    r,
    t,
    /*$$scope*/
    t[0],
    null
  );
  return {
    c() {
      e = I("div"), i && i.c(), b(e, "class", "rcb-modal-backdrop svelte-17tslso");
    },
    m(o, s) {
      g(o, e, s), i && i.m(e, null), n = !0;
    },
    p(o, [s]) {
      i && i.p && (!n || s & /*$$scope*/
      1) && V(
        i,
        r,
        o,
        /*$$scope*/
        o[0],
        n ? G(
          r,
          /*$$scope*/
          o[0],
          s,
          null
        ) : Y(
          /*$$scope*/
          o[0]
        ),
        null
      );
    },
    i(o) {
      n || (d(i, o), n = !0);
    },
    o(o) {
      p(i, o), n = !1;
    },
    d(o) {
      o && _(e), i && i.d(o);
    }
  };
}
function rs(t, e, n) {
  let { $$slots: r = {}, $$scope: i } = e;
  return t.$$set = (o) => {
    "$$scope" in o && n(0, i = o.$$scope);
  }, [i, r];
}
class is extends D {
  constructor(e) {
    super(), M(this, e, rs, ns, S, {}, ts);
  }
}
function os(t) {
  F(t, "svelte-1fufj5b", ".rcb-modal-container.svelte-1fufj5b{width:100%}.rcb-modal-main.svelte-1fufj5b{box-sizing:border-box;border-radius:var(--rc-shape-modal-border-radius);background-color:var(--rc-color-background);color:var(--rc-color-grey-text-dark);padding:40px;flex-direction:column;display:flex}@media screen and (max-width: 960px){.rcb-modal-container.svelte-1fufj5b{width:calc(100% - 32px);min-width:300px;max-width:640px;margin:auto}.rcb-modal-main.svelte-1fufj5b{min-width:300px;max-width:640px;padding:32px}}");
}
function ss(t) {
  let e, n, r;
  const i = (
    /*#slots*/
    t[2].default
  ), o = q(
    i,
    t,
    /*$$scope*/
    t[1],
    null
  );
  return {
    c() {
      e = I("div"), n = I("main"), o && o.c(), b(n, "class", "rcb-modal-main svelte-1fufj5b"), b(
        n,
        "style",
        /*style*/
        t[0]
      ), b(e, "class", "rcb-modal-container svelte-1fufj5b");
    },
    m(s, l) {
      g(s, e, l), L(e, n), o && o.m(n, null), r = !0;
    },
    p(s, [l]) {
      o && o.p && (!r || l & /*$$scope*/
      2) && V(
        o,
        i,
        s,
        /*$$scope*/
        s[1],
        r ? G(
          i,
          /*$$scope*/
          s[1],
          l,
          null
        ) : Y(
          /*$$scope*/
          s[1]
        ),
        null
      ), (!r || l & /*style*/
      1) && b(
        n,
        "style",
        /*style*/
        s[0]
      );
    },
    i(s) {
      r || (d(o, s), r = !0);
    },
    o(s) {
      p(o, s), r = !1;
    },
    d(s) {
      s && _(e), o && o.d(s);
    }
  };
}
function ls(t, e, n) {
  let { $$slots: r = {}, $$scope: i } = e, { style: o = "" } = e;
  return t.$$set = (s) => {
    "style" in s && n(0, o = s.style), "$$scope" in s && n(1, i = s.$$scope);
  }, [o, i, r];
}
class gn extends D {
  constructor(e) {
    super(), M(this, e, ls, ss, S, { style: 0 }, os);
  }
}
function as(t) {
  let e;
  const n = (
    /*#slots*/
    t[1].default
  ), r = q(
    n,
    t,
    /*$$scope*/
    t[2],
    null
  );
  return {
    c() {
      r && r.c();
    },
    m(i, o) {
      r && r.m(i, o), e = !0;
    },
    p(i, o) {
      r && r.p && (!e || o & /*$$scope*/
      4) && V(
        r,
        n,
        i,
        /*$$scope*/
        i[2],
        e ? G(
          n,
          /*$$scope*/
          i[2],
          o,
          null
        ) : Y(
          /*$$scope*/
          i[2]
        ),
        null
      );
    },
    i(i) {
      e || (d(r, i), e = !0);
    },
    o(i) {
      p(r, i), e = !1;
    },
    d(i) {
      r && r.d(i);
    }
  };
}
function cs(t) {
  let e, n;
  return e = new is({
    props: {
      $$slots: { default: [us] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p(r, i) {
      const o = {};
      i & /*$$scope*/
      4 && (o.$$scope = { dirty: i, ctx: r }), e.$set(o);
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function us(t) {
  let e;
  const n = (
    /*#slots*/
    t[1].default
  ), r = q(
    n,
    t,
    /*$$scope*/
    t[2],
    null
  );
  return {
    c() {
      r && r.c();
    },
    m(i, o) {
      r && r.m(i, o), e = !0;
    },
    p(i, o) {
      r && r.p && (!e || o & /*$$scope*/
      4) && V(
        r,
        n,
        i,
        /*$$scope*/
        i[2],
        e ? G(
          n,
          /*$$scope*/
          i[2],
          o,
          null
        ) : Y(
          /*$$scope*/
          i[2]
        ),
        null
      );
    },
    i(i) {
      e || (d(r, i), e = !0);
    },
    o(i) {
      p(r, i), e = !1;
    },
    d(i) {
      r && r.d(i);
    }
  };
}
function fs(t) {
  let e, n, r, i;
  const o = [cs, as], s = [];
  function l(a, c) {
    return (
      /*condition*/
      a[0] ? 0 : 1
    );
  }
  return e = l(t), n = s[e] = o[e](t), {
    c() {
      n.c(), r = ee();
    },
    m(a, c) {
      s[e].m(a, c), g(a, r, c), i = !0;
    },
    p(a, [c]) {
      let f = e;
      e = l(a), e === f ? s[e].p(a, c) : (z(), p(s[f], 1, 1, () => {
        s[f] = null;
      }), W(), n = s[e], n ? n.p(a, c) : (n = s[e] = o[e](a), n.c()), d(n, 1), n.m(r.parentNode, r));
    },
    i(a) {
      i || (d(n), i = !0);
    },
    o(a) {
      p(n), i = !1;
    },
    d(a) {
      a && _(r), s[e].d(a);
    }
  };
}
function ds(t, e, n) {
  let { $$slots: r = {}, $$scope: i } = e, { condition: o = !1 } = e;
  return t.$$set = (s) => {
    "condition" in s && n(0, o = s.condition), "$$scope" in s && n(2, i = s.$$scope);
  }, [o, r, i];
}
class ps extends D {
  constructor(e) {
    super(), M(this, e, ds, fs, S, { condition: 0 });
  }
}
const ms = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
     xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.5" clip-path="url(#clip0_344_3390)">
        <path d="M7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM1 2V4H3L6.6 11.59L5.25 14.04C5.09 14.32 5 14.65 5 15C5 16.1 5.9 17 7 17H19V15H7.42C7.28 15 7.17 14.89 7.17 14.75L7.2 14.63L8.1 13H15.55C16.3 13 16.96 12.59 17.3 11.97L20.88 5.48C20.96 5.34 21 5.17 21 5C21 4.45 20.55 4 20 4H5.21L4.27 2H1ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18Z"
              fill="currentColor"/>
    </g>
    <defs>
        <clipPath id="clip0_344_3390">
            <rect width="24" height="24" fill="currentColor"/>
        </clipPath>
    </defs>
</svg>
`;
function _s(t) {
  let e;
  return {
    c() {
      e = I("div"), ne(e, "color", "var(--rc-color-gray-text-dark)");
    },
    m(n, r) {
      g(n, e, r), e.innerHTML = ms;
    },
    p: A,
    i: A,
    o: A,
    d(n) {
      n && _(e);
    }
  };
}
class gs extends D {
  constructor(e) {
    super(), M(this, e, null, _s, S, {});
  }
}
function hs(t) {
  F(t, "svelte-1ny4y2s", "div.svelte-1ny4y2s{background-color:var(--rc-color-warning);color:rgba(0,0,0,1);font-size:10px;font-weight:bold;text-transform:uppercase;padding:4px 10px;line-height:10px;border-radius:9px;margin:0px;margin-left:16px}");
}
function bs(t) {
  let e;
  return {
    c() {
      e = I("div"), e.textContent = "Sandbox", b(e, "class", "svelte-1ny4y2s");
    },
    m(n, r) {
      g(n, e, r);
    },
    p: A,
    i: A,
    o: A,
    d(n) {
      n && _(e);
    }
  };
}
class ws extends D {
  constructor(e) {
    super(), M(this, e, null, bs, S, {}, hs);
  }
}
function ys(t) {
  F(t, "svelte-1iuls9l", ".rcb-ui-layout.svelte-1iuls9l{width:100vw;margin-right:auto;display:flex;justify-content:center;align-items:flex-start;position:relative;padding:0px 80px;box-sizing:border-box}@media screen and (max-width: 960px){.rcb-ui-layout.svelte-1iuls9l{flex-direction:column;align-items:center;justify-content:center;height:100%;min-width:100%}}@media screen and (max-width: 960px) and (max-height: 960px){.rcb-ui-layout.svelte-1iuls9l{overflow-y:scroll;justify-content:flex-start;padding:16px 0}}");
}
function Es(t) {
  let e, n;
  const r = (
    /*#slots*/
    t[2].default
  ), i = q(
    r,
    t,
    /*$$scope*/
    t[1],
    null
  );
  return {
    c() {
      e = I("div"), i && i.c(), b(e, "class", "rcb-ui-layout svelte-1iuls9l"), b(
        e,
        "style",
        /*style*/
        t[0]
      );
    },
    m(o, s) {
      g(o, e, s), i && i.m(e, null), n = !0;
    },
    p(o, [s]) {
      i && i.p && (!n || s & /*$$scope*/
      2) && V(
        i,
        r,
        o,
        /*$$scope*/
        o[1],
        n ? G(
          r,
          /*$$scope*/
          o[1],
          s,
          null
        ) : Y(
          /*$$scope*/
          o[1]
        ),
        null
      ), (!n || s & /*style*/
      1) && b(
        e,
        "style",
        /*style*/
        o[0]
      );
    },
    i(o) {
      n || (d(i, o), n = !0);
    },
    o(o) {
      p(i, o), n = !1;
    },
    d(o) {
      o && _(e), i && i.d(o);
    }
  };
}
function Is(t, e, n) {
  let { $$slots: r = {}, $$scope: i } = e, { style: o = "" } = e;
  return t.$$set = (s) => {
    "style" in s && n(0, o = s.style), "$$scope" in s && n(1, i = s.$$scope);
  }, [o, i, r];
}
class vs extends D {
  constructor(e) {
    super(), M(this, e, Is, Es, S, { style: 0 }, ys);
  }
}
function $s(t) {
  F(t, "svelte-1sfb5if", `.rcb-ui-container.svelte-1sfb5if{color-scheme:none;font-size:16px;line-height:1.5em;font-weight:400;font-family:-apple-system, "system-ui", "Segoe UI", Roboto, Oxygen, Ubuntu,
        Cantarell, "Open Sans", "Helvetica Neue", sans-serif}`);
}
function ks(t) {
  let e, n;
  const r = (
    /*#slots*/
    t[2].default
  ), i = q(
    r,
    t,
    /*$$scope*/
    t[1],
    null
  );
  return {
    c() {
      e = I("div"), i && i.c(), b(e, "class", "rcb-ui-container svelte-1sfb5if"), b(
        e,
        "style",
        /*style*/
        t[0]
      );
    },
    m(o, s) {
      g(o, e, s), i && i.m(e, null), n = !0;
    },
    p(o, [s]) {
      i && i.p && (!n || s & /*$$scope*/
      2) && V(
        i,
        r,
        o,
        /*$$scope*/
        o[1],
        n ? G(
          r,
          /*$$scope*/
          o[1],
          s,
          null
        ) : Y(
          /*$$scope*/
          o[1]
        ),
        null
      ), (!n || s & /*style*/
      1) && b(
        e,
        "style",
        /*style*/
        o[0]
      );
    },
    i(o) {
      n || (d(i, o), n = !0);
    },
    o(o) {
      p(i, o), n = !1;
    },
    d(o) {
      o && _(e), i && i.d(o);
    }
  };
}
function Ps(t, e, n) {
  let { $$slots: r = {}, $$scope: i } = e, { style: o = "" } = e;
  return t.$$set = (s) => {
    "style" in s && n(0, o = s.style), "$$scope" in s && n(1, i = s.$$scope);
  }, [o, i, r];
}
class Ts extends D {
  constructor(e) {
    super(), M(this, e, Ps, ks, S, { style: 0 }, $s);
  }
}
function As(t) {
  F(t, "svelte-17dr902", ".rcb-ui-aside.svelte-17dr902{margin-right:16px;flex:320px 1 0;max-width:480px}@media screen and (max-width: 960px){.rcb-ui-aside.svelte-17dr902{margin-right:0;margin-bottom:16px;min-width:100%;display:flex;flex-direction:column;align-items:center;flex:none;max-width:none}}");
}
const Os = (t) => ({}), Mt = (t) => ({});
function Ns(t) {
  let e, n;
  const r = (
    /*#slots*/
    t[2].header
  ), i = q(
    r,
    t,
    /*$$scope*/
    t[3],
    Mt
  ), o = (
    /*#slots*/
    t[2].default
  ), s = q(
    o,
    t,
    /*$$scope*/
    t[3],
    null
  );
  return {
    c() {
      i && i.c(), e = U(), s && s.c();
    },
    m(l, a) {
      i && i.m(l, a), g(l, e, a), s && s.m(l, a), n = !0;
    },
    p(l, a) {
      i && i.p && (!n || a & /*$$scope*/
      8) && V(
        i,
        r,
        l,
        /*$$scope*/
        l[3],
        n ? G(
          r,
          /*$$scope*/
          l[3],
          a,
          Os
        ) : Y(
          /*$$scope*/
          l[3]
        ),
        Mt
      ), s && s.p && (!n || a & /*$$scope*/
      8) && V(
        s,
        o,
        l,
        /*$$scope*/
        l[3],
        n ? G(
          o,
          /*$$scope*/
          l[3],
          a,
          null
        ) : Y(
          /*$$scope*/
          l[3]
        ),
        null
      );
    },
    i(l) {
      n || (d(i, l), d(s, l), n = !0);
    },
    o(l) {
      p(i, l), p(s, l), n = !1;
    },
    d(l) {
      l && _(e), i && i.d(l), s && s.d(l);
    }
  };
}
function Us(t) {
  let e, n, r;
  return n = new gn({
    props: {
      $$slots: { default: [Ns] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      e = I("div"), k(n.$$.fragment), b(e, "class", "rcb-ui-aside svelte-17dr902"), b(
        e,
        "style",
        /*style*/
        t[0]
      );
    },
    m(i, o) {
      g(i, e, o), v(n, e, null), r = !0;
    },
    p(i, [o]) {
      const s = {};
      o & /*$$scope*/
      8 && (s.$$scope = { dirty: o, ctx: i }), n.$set(s);
    },
    i(i) {
      r || (d(n.$$.fragment, i), r = !0);
    },
    o(i) {
      p(n.$$.fragment, i), r = !1;
    },
    d(i) {
      i && _(e), $(n);
    }
  };
}
function Rs(t, e, n) {
  let { $$slots: r = {}, $$scope: i } = e, { brandingAppearance: o = void 0 } = e, s = new lt(o).productInfoStyleVars;
  return t.$$set = (l) => {
    "brandingAppearance" in l && n(1, o = l.brandingAppearance), "$$scope" in l && n(3, i = l.$$scope);
  }, [s, o, r, i];
}
class Ls extends D {
  constructor(e) {
    super(), M(this, e, Rs, Us, S, { brandingAppearance: 1 }, As);
  }
}
function Ss(t) {
  F(t, "svelte-vpgys", ".rcb-ui-main.svelte-vpgys{flex:480px 1 0;max-width:640px}@media screen and (max-width: 960px){.rcb-ui-main.svelte-vpgys{flex:none;max-width:none;min-width:100%}}");
}
const Ms = (t) => ({}), Dt = (t) => ({});
function Ds(t) {
  let e, n;
  const r = (
    /*#slots*/
    t[2].header
  ), i = q(
    r,
    t,
    /*$$scope*/
    t[3],
    Dt
  ), o = (
    /*#slots*/
    t[2].default
  ), s = q(
    o,
    t,
    /*$$scope*/
    t[3],
    null
  );
  return {
    c() {
      i && i.c(), e = U(), s && s.c();
    },
    m(l, a) {
      i && i.m(l, a), g(l, e, a), s && s.m(l, a), n = !0;
    },
    p(l, a) {
      i && i.p && (!n || a & /*$$scope*/
      8) && V(
        i,
        r,
        l,
        /*$$scope*/
        l[3],
        n ? G(
          r,
          /*$$scope*/
          l[3],
          a,
          Ms
        ) : Y(
          /*$$scope*/
          l[3]
        ),
        Dt
      ), s && s.p && (!n || a & /*$$scope*/
      8) && V(
        s,
        o,
        l,
        /*$$scope*/
        l[3],
        n ? G(
          o,
          /*$$scope*/
          l[3],
          a,
          null
        ) : Y(
          /*$$scope*/
          l[3]
        ),
        null
      );
    },
    i(l) {
      n || (d(i, l), d(s, l), n = !0);
    },
    o(l) {
      p(i, l), p(s, l), n = !1;
    },
    d(l) {
      l && _(e), i && i.d(l), s && s.d(l);
    }
  };
}
function Bs(t) {
  let e, n, r;
  return n = new gn({
    props: {
      style: "min-height: 360px;",
      $$slots: { default: [Ds] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      e = I("div"), k(n.$$.fragment), b(e, "class", "rcb-ui-main svelte-vpgys"), b(
        e,
        "style",
        /*style*/
        t[0]
      );
    },
    m(i, o) {
      g(i, e, o), v(n, e, null), r = !0;
    },
    p(i, [o]) {
      const s = {};
      o & /*$$scope*/
      8 && (s.$$scope = { dirty: o, ctx: i }), n.$set(s);
    },
    i(i) {
      r || (d(n.$$.fragment, i), r = !0);
    },
    o(i) {
      p(n.$$.fragment, i), r = !1;
    },
    d(i) {
      i && _(e), $(n);
    }
  };
}
function Cs(t, e, n) {
  let { $$slots: r = {}, $$scope: i } = e, { brandingAppearance: o = void 0 } = e, s = new lt(o).formStyleVars;
  return t.$$set = (l) => {
    "brandingAppearance" in l && n(1, o = l.brandingAppearance), "$$scope" in l && n(3, i = l.$$scope);
  }, [s, o, r, i];
}
class Fs extends D {
  constructor(e) {
    super(), M(this, e, Cs, Bs, S, { brandingAppearance: 1 }, Ss);
  }
}
function Bt(t) {
  var r;
  let e, n;
  return e = new Ls({
    props: {
      brandingAppearance: (
        /*brandingInfo*/
        (r = t[1]) == null ? void 0 : r.appearance
      ),
      $$slots: {
        header: [Gs],
        default: [js]
      },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      k(e.$$.fragment);
    },
    m(i, o) {
      v(e, i, o), n = !0;
    },
    p(i, o) {
      var l;
      const s = {};
      o & /*brandingInfo*/
      2 && (s.brandingAppearance = /*brandingInfo*/
      (l = i[1]) == null ? void 0 : l.appearance), o & /*$$scope, purchases, brandingInfo, productDetails*/
      33554454 && (s.$$scope = { dirty: o, ctx: i }), e.$set(s);
    },
    i(i) {
      n || (d(e.$$.fragment, i), n = !0);
    },
    o(i) {
      p(e.$$.fragment, i), n = !1;
    },
    d(i) {
      $(e, i);
    }
  };
}
function Ct(t) {
  var r;
  let e, n;
  return e = new en({
    props: {
      productDetails: (
        /*productDetails*/
        t[4]
      ),
      brandingAppearance: (
        /*brandingInfo*/
        (r = t[1]) == null ? void 0 : r.appearance
      ),
      purchaseOption: (
        /*purchaseOptionToUse*/
        t[8]
      )
    }
  }), {
    c() {
      k(e.$$.fragment);
    },
    m(i, o) {
      v(e, i, o), n = !0;
    },
    p(i, o) {
      var l;
      const s = {};
      o & /*productDetails*/
      16 && (s.productDetails = /*productDetails*/
      i[4]), o & /*brandingInfo*/
      2 && (s.brandingAppearance = /*brandingInfo*/
      (l = i[1]) == null ? void 0 : l.appearance), e.$set(s);
    },
    i(i) {
      n || (d(e.$$.fragment, i), n = !0);
    },
    o(i) {
      p(e.$$.fragment, i), n = !1;
    },
    d(i) {
      $(e, i);
    }
  };
}
function js(t) {
  let e, n, r = (
    /*productDetails*/
    t[4] && /*purchaseOptionToUse*/
    t[8] && Ct(t)
  );
  return {
    c() {
      r && r.c(), e = ee();
    },
    m(i, o) {
      r && r.m(i, o), g(i, e, o), n = !0;
    },
    p(i, o) {
      /*productDetails*/
      i[4] && /*purchaseOptionToUse*/
      i[8] ? r ? (r.p(i, o), o & /*productDetails*/
      16 && d(r, 1)) : (r = Ct(i), r.c(), d(r, 1), r.m(e.parentNode, e)) : r && (z(), p(r, 1, 1, () => {
        r = null;
      }), W());
    },
    i(i) {
      n || (d(r), n = !0);
    },
    o(i) {
      p(r), n = !1;
    },
    d(i) {
      i && _(e), r && r.d(i);
    }
  };
}
function Hs(t) {
  let e, n;
  return e = new gs({}), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function xs(t) {
  let e, n;
  return e = new ws({}), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function qs(t) {
  let e, n, r, i, o, s, l;
  e = new rn({
    props: { brandingInfo: (
      /*brandingInfo*/
      t[1]
    ) }
  });
  const a = [xs, Hs], c = [];
  function f(u, m) {
    return m & /*purchases*/
    4 && (r = null), r == null && (r = !!/*purchases*/
    u[2].isSandbox()), r ? 0 : 1;
  }
  return i = f(t, -1), o = c[i] = a[i](t), {
    c() {
      k(e.$$.fragment), n = U(), o.c(), s = ee();
    },
    m(u, m) {
      v(e, u, m), g(u, n, m), c[i].m(u, m), g(u, s, m), l = !0;
    },
    p(u, m) {
      const h = {};
      m & /*brandingInfo*/
      2 && (h.brandingInfo = /*brandingInfo*/
      u[1]), e.$set(h);
      let y = i;
      i = f(u, m), i !== y && (z(), p(c[y], 1, 1, () => {
        c[y] = null;
      }), W(), o = c[i], o || (o = c[i] = a[i](u), o.c()), d(o, 1), o.m(s.parentNode, s));
    },
    i(u) {
      l || (d(e.$$.fragment, u), d(o), l = !0);
    },
    o(u) {
      p(e.$$.fragment, u), p(o), l = !1;
    },
    d(u) {
      u && (_(n), _(s)), $(e, u), c[i].d(u);
    }
  };
}
function Gs(t) {
  let e, n;
  return e = new ot({
    props: {
      slot: "header",
      $$slots: { default: [qs] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p(r, i) {
      const o = {};
      i & /*$$scope, purchases, brandingInfo*/
      33554438 && (o.$$scope = { dirty: i, ctx: r }), e.$set(o);
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function Ft(t) {
  let e, n;
  return e = new en({
    props: {
      productDetails: (
        /*productDetails*/
        t[4]
      ),
      purchaseOption: (
        /*purchaseOptionToUse*/
        t[8]
      )
    }
  }), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p(r, i) {
      const o = {};
      i & /*productDetails*/
      16 && (o.productDetails = /*productDetails*/
      r[4]), e.$set(o);
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function jt(t) {
  let e, n;
  return e = new tt({}), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function Ht(t) {
  let e, n;
  return e = new es({
    props: {
      onContinue: (
        /*handleContinue*/
        t[11]
      ),
      onClose: (
        /*handleClose*/
        t[10]
      ),
      processing: (
        /*state*/
        t[7] === "processing-auth-info"
      ),
      lastError: (
        /*lastError*/
        t[6]
      )
    }
  }), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p(r, i) {
      const o = {};
      i & /*state*/
      128 && (o.processing = /*state*/
      r[7] === "processing-auth-info"), i & /*lastError*/
      64 && (o.lastError = /*lastError*/
      r[6]), e.$set(o);
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function xt(t) {
  let e, n;
  return e = new Ho({
    props: {
      paymentInfoCollectionMetadata: (
        /*paymentInfoCollectionMetadata*/
        t[5]
      ),
      onContinue: (
        /*handleContinue*/
        t[11]
      ),
      onClose: (
        /*handleClose*/
        t[10]
      ),
      onError: (
        /*handleError*/
        t[12]
      ),
      processing: (
        /*state*/
        t[7] === "polling-purchase-status"
      ),
      productDetails: (
        /*productDetails*/
        t[4]
      ),
      purchaseOptionToUse: (
        /*purchaseOptionToUse*/
        t[8]
      ),
      brandingInfo: (
        /*brandingInfo*/
        t[1]
      )
    }
  }), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p(r, i) {
      const o = {};
      i & /*paymentInfoCollectionMetadata*/
      32 && (o.paymentInfoCollectionMetadata = /*paymentInfoCollectionMetadata*/
      r[5]), i & /*state*/
      128 && (o.processing = /*state*/
      r[7] === "polling-purchase-status"), i & /*productDetails*/
      16 && (o.productDetails = /*productDetails*/
      r[4]), i & /*brandingInfo*/
      2 && (o.brandingInfo = /*brandingInfo*/
      r[1]), e.$set(o);
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function qt(t) {
  let e, n;
  return e = new tt({}), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function Gt(t) {
  var r;
  let e, n;
  return e = new Ni({
    props: {
      brandingInfo: (
        /*brandingInfo*/
        t[1]
      ),
      lastError: (
        /*lastError*/
        t[6] ?? new x(K.UnknownError, "Unknown error without state set.")
      ),
      supportEmail: (
        /*brandingInfo*/
        (r = t[1]) == null ? void 0 : r.seller_company_support_email
      ),
      productDetails: (
        /*productDetails*/
        t[4]
      ),
      onContinue: (
        /*closeWithError*/
        t[13]
      )
    }
  }), {
    c() {
      k(e.$$.fragment);
    },
    m(i, o) {
      v(e, i, o), n = !0;
    },
    p(i, o) {
      var l;
      const s = {};
      o & /*brandingInfo*/
      2 && (s.brandingInfo = /*brandingInfo*/
      i[1]), o & /*lastError*/
      64 && (s.lastError = /*lastError*/
      i[6] ?? new x(K.UnknownError, "Unknown error without state set.")), o & /*brandingInfo*/
      2 && (s.supportEmail = /*brandingInfo*/
      (l = i[1]) == null ? void 0 : l.seller_company_support_email), o & /*productDetails*/
      16 && (s.productDetails = /*productDetails*/
      i[4]), e.$set(s);
    },
    i(i) {
      n || (d(e.$$.fragment, i), n = !0);
    },
    o(i) {
      p(e.$$.fragment, i), n = !1;
    },
    d(i) {
      $(e, i);
    }
  };
}
function Vt(t) {
  let e, n;
  return e = new ji({
    props: {
      productDetails: (
        /*productDetails*/
        t[4]
      ),
      brandingInfo: (
        /*brandingInfo*/
        t[1]
      ),
      onContinue: (
        /*handleContinue*/
        t[11]
      )
    }
  }), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p(r, i) {
      const o = {};
      i & /*productDetails*/
      16 && (o.productDetails = /*productDetails*/
      r[4]), i & /*brandingInfo*/
      2 && (o.brandingInfo = /*brandingInfo*/
      r[1]), e.$set(o);
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function Vs(t) {
  let e, n, r, i, o, s, l, a, c = (
    /*state*/
    t[7] === "present-offer" && /*productDetails*/
    t[4] && /*purchaseOptionToUse*/
    t[8] && Ft(t)
  ), f = (
    /*state*/
    t[7] === "present-offer" && !/*productDetails*/
    t[4] && jt()
  ), u = (
    /*state*/
    (t[7] === "needs-auth-info" || /*state*/
    t[7] === "processing-auth-info") && Ht(t)
  ), m = (
    /*paymentInfoCollectionMetadata*/
    t[5] && /*state*/
    (t[7] === "needs-payment-info" || /*state*/
    t[7] === "polling-purchase-status") && /*productDetails*/
    t[4] && /*purchaseOptionToUse*/
    t[8] && xt(t)
  ), h = (
    /*state*/
    t[7] === "loading" && qt()
  ), y = (
    /*state*/
    t[7] === "error" && Gt(t)
  ), T = (
    /*state*/
    t[7] === "success" && Vt(t)
  );
  return {
    c() {
      c && c.c(), e = U(), f && f.c(), n = U(), u && u.c(), r = U(), m && m.c(), i = U(), h && h.c(), o = U(), y && y.c(), s = U(), T && T.c(), l = ee();
    },
    m(w, O) {
      c && c.m(w, O), g(w, e, O), f && f.m(w, O), g(w, n, O), u && u.m(w, O), g(w, r, O), m && m.m(w, O), g(w, i, O), h && h.m(w, O), g(w, o, O), y && y.m(w, O), g(w, s, O), T && T.m(w, O), g(w, l, O), a = !0;
    },
    p(w, O) {
      /*state*/
      w[7] === "present-offer" && /*productDetails*/
      w[4] && /*purchaseOptionToUse*/
      w[8] ? c ? (c.p(w, O), O & /*state, productDetails*/
      144 && d(c, 1)) : (c = Ft(w), c.c(), d(c, 1), c.m(e.parentNode, e)) : c && (z(), p(c, 1, 1, () => {
        c = null;
      }), W()), /*state*/
      w[7] === "present-offer" && !/*productDetails*/
      w[4] ? f ? O & /*state, productDetails*/
      144 && d(f, 1) : (f = jt(), f.c(), d(f, 1), f.m(n.parentNode, n)) : f && (z(), p(f, 1, 1, () => {
        f = null;
      }), W()), /*state*/
      w[7] === "needs-auth-info" || /*state*/
      w[7] === "processing-auth-info" ? u ? (u.p(w, O), O & /*state*/
      128 && d(u, 1)) : (u = Ht(w), u.c(), d(u, 1), u.m(r.parentNode, r)) : u && (z(), p(u, 1, 1, () => {
        u = null;
      }), W()), /*paymentInfoCollectionMetadata*/
      w[5] && /*state*/
      (w[7] === "needs-payment-info" || /*state*/
      w[7] === "polling-purchase-status") && /*productDetails*/
      w[4] && /*purchaseOptionToUse*/
      w[8] ? m ? (m.p(w, O), O & /*paymentInfoCollectionMetadata, state, productDetails*/
      176 && d(m, 1)) : (m = xt(w), m.c(), d(m, 1), m.m(i.parentNode, i)) : m && (z(), p(m, 1, 1, () => {
        m = null;
      }), W()), /*state*/
      w[7] === "loading" ? h ? O & /*state*/
      128 && d(h, 1) : (h = qt(), h.c(), d(h, 1), h.m(o.parentNode, o)) : h && (z(), p(h, 1, 1, () => {
        h = null;
      }), W()), /*state*/
      w[7] === "error" ? y ? (y.p(w, O), O & /*state*/
      128 && d(y, 1)) : (y = Gt(w), y.c(), d(y, 1), y.m(s.parentNode, s)) : y && (z(), p(y, 1, 1, () => {
        y = null;
      }), W()), /*state*/
      w[7] === "success" ? T ? (T.p(w, O), O & /*state*/
      128 && d(T, 1)) : (T = Vt(w), T.c(), d(T, 1), T.m(l.parentNode, l)) : T && (z(), p(T, 1, 1, () => {
        T = null;
      }), W());
    },
    i(w) {
      a || (d(c), d(f), d(u), d(m), d(h), d(y), d(T), a = !0);
    },
    o(w) {
      p(c), p(f), p(u), p(m), p(h), p(y), p(T), a = !1;
    },
    d(w) {
      w && (_(e), _(n), _(r), _(i), _(o), _(s), _(l)), c && c.d(w), f && f.d(w), u && u.d(w), m && m.d(w), h && h.d(w), y && y.d(w), T && T.d(w);
    }
  };
}
function Ys(t) {
  var s;
  let e = (
    /*statesWhereOfferDetailsAreShown*/
    t[9].includes(
      /*state*/
      t[7]
    )
  ), n, r, i, o = e && Bt(t);
  return r = new Fs({
    props: {
      brandingAppearance: (
        /*brandingInfo*/
        (s = t[1]) == null ? void 0 : s.appearance
      ),
      $$slots: { default: [Vs] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      o && o.c(), n = U(), k(r.$$.fragment);
    },
    m(l, a) {
      o && o.m(l, a), g(l, n, a), v(r, l, a), i = !0;
    },
    p(l, a) {
      var f;
      a & /*state*/
      128 && (e = /*statesWhereOfferDetailsAreShown*/
      l[9].includes(
        /*state*/
        l[7]
      )), e ? o ? (o.p(l, a), a & /*state*/
      128 && d(o, 1)) : (o = Bt(l), o.c(), d(o, 1), o.m(n.parentNode, n)) : o && (z(), p(o, 1, 1, () => {
        o = null;
      }), W());
      const c = {};
      a & /*brandingInfo*/
      2 && (c.brandingAppearance = /*brandingInfo*/
      (f = l[1]) == null ? void 0 : f.appearance), a & /*$$scope, productDetails, brandingInfo, state, lastError, paymentInfoCollectionMetadata*/
      33554674 && (c.$$scope = { dirty: a, ctx: l }), r.$set(c);
    },
    i(l) {
      i || (d(o), d(r.$$.fragment, l), i = !0);
    },
    o(l) {
      p(o), p(r.$$.fragment, l), i = !1;
    },
    d(l) {
      l && _(n), o && o.d(l), $(r, l);
    }
  };
}
function zs(t) {
  let e, n;
  return e = new vs({
    props: {
      style: (
        /*colorVariables*/
        t[3]
      ),
      $$slots: { default: [Ys] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p(r, i) {
      const o = {};
      i & /*colorVariables*/
      8 && (o.style = /*colorVariables*/
      r[3]), i & /*$$scope, brandingInfo, productDetails, state, lastError, paymentInfoCollectionMetadata, purchases*/
      33554678 && (o.$$scope = { dirty: i, ctx: r }), e.$set(o);
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function Ws(t) {
  let e, n;
  return e = new ps({
    props: {
      condition: (
        /*asModal*/
        t[0]
      ),
      $$slots: { default: [zs] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p(r, i) {
      const o = {};
      i & /*asModal*/
      1 && (o.condition = /*asModal*/
      r[0]), i & /*$$scope, colorVariables, brandingInfo, productDetails, state, lastError, paymentInfoCollectionMetadata, purchases*/
      33554686 && (o.$$scope = { dirty: i, ctx: r }), e.$set(o);
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function Ks(t) {
  let e, n;
  return e = new Ts({
    props: {
      $$slots: { default: [Ws] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      k(e.$$.fragment);
    },
    m(r, i) {
      v(e, r, i), n = !0;
    },
    p(r, [i]) {
      const o = {};
      i & /*$$scope, asModal, colorVariables, brandingInfo, productDetails, state, lastError, paymentInfoCollectionMetadata, purchases*/
      33554687 && (o.$$scope = { dirty: i, ctx: r }), e.$set(o);
    },
    i(r) {
      n || (d(e.$$.fragment, r), n = !0);
    },
    o(r) {
      p(e.$$.fragment, r), n = !1;
    },
    d(r) {
      $(e, r);
    }
  };
}
function Qs(t, e, n) {
  let { asModal: r = !0 } = e, { customerEmail: i } = e, { appUserId: o } = e, { rcPackage: s } = e, { purchaseOption: l } = e, { brandingInfo: a } = e, { onFinished: c } = e, { onError: f } = e, { onClose: u } = e, { purchases: m } = e, { purchaseOperationHelper: h } = e, y = "", T = null, w = null, O = null;
  const C = s.rcBillingProduct.identifier ?? null, E = s.rcBillingProduct.defaultPurchaseOption, P = l || E;
  let B = "present-offer";
  const Ae = [
    "present-offer",
    "needs-auth-info",
    "processing-auth-info",
    "needs-payment-info",
    "polling-purchase-status",
    "loading"
  ];
  Fe(async () => {
    if (n(4, T = s.rcBillingProduct), n(3, y = _n(a == null ? void 0 : a.appearance)), B === "present-offer") {
      i ? at() : n(7, B = "needs-auth-info");
      return;
    }
  });
  const Oe = () => {
    u();
  }, at = () => {
    if (C === null) {
      pe(new x(K.ErrorSettingUpPurchase, "Product ID was not set before purchase."));
      return;
    } else B === "present-offer" && n(7, B = "loading");
    if (!i) {
      pe(new x(K.MissingEmailError));
      return;
    }
    h.startPurchase(o, C, P, i, s.rcBillingProduct.presentedOfferingContext).then((R) => {
      if (R.next_action === "collect_payment_info") {
        n(6, O = null), n(7, B = "needs-payment-info"), n(5, w = R);
        return;
      }
      if (R.next_action === "completed") {
        n(6, O = null), n(7, B = "success");
        return;
      }
    }).catch((R) => {
      pe(R);
    });
  }, Pn = (R) => {
    if (B === "needs-auth-info") {
      R && (n(14, i = R.email), n(7, B = "processing-auth-info")), at();
      return;
    }
    if (B === "needs-payment-info") {
      n(7, B = "polling-purchase-status"), h.pollCurrentPurchaseForCompletion().then(() => {
        n(7, B = "success");
      }).catch((An) => {
        pe(An);
      });
      return;
    }
    if (B === "success" || B === "error") {
      c();
      return;
    }
    n(7, B = "success");
  }, pe = (R) => {
    if (B === "processing-auth-info" && R.isRecoverable()) {
      n(6, O = R), n(7, B = "needs-auth-info");
      return;
    }
    n(6, O = R), n(7, B = "error");
  }, Tn = () => {
    f(O ?? new x(K.UnknownError, "Unknown error without state set."));
  };
  return t.$$set = (R) => {
    "asModal" in R && n(0, r = R.asModal), "customerEmail" in R && n(14, i = R.customerEmail), "appUserId" in R && n(15, o = R.appUserId), "rcPackage" in R && n(16, s = R.rcPackage), "purchaseOption" in R && n(17, l = R.purchaseOption), "brandingInfo" in R && n(1, a = R.brandingInfo), "onFinished" in R && n(18, c = R.onFinished), "onError" in R && n(19, f = R.onError), "onClose" in R && n(20, u = R.onClose), "purchases" in R && n(2, m = R.purchases), "purchaseOperationHelper" in R && n(21, h = R.purchaseOperationHelper);
  }, [
    r,
    a,
    m,
    y,
    T,
    w,
    O,
    B,
    P,
    Ae,
    Oe,
    Pn,
    pe,
    Tn,
    i,
    o,
    s,
    l,
    c,
    f,
    u,
    h
  ];
}
class Xs extends D {
  constructor(e) {
    super(), M(this, e, Qs, Ks, S, {
      asModal: 0,
      customerEmail: 14,
      appUserId: 15,
      rcPackage: 16,
      purchaseOption: 17,
      brandingInfo: 1,
      onFinished: 18,
      onError: 19,
      onClose: 20,
      purchases: 2,
      purchaseOperationHelper: 21
    });
  }
}
function Zs(t) {
  return t.expires_date == null ? !0 : new Date(t.expires_date) > /* @__PURE__ */ new Date();
}
function Js(t, e, n, r) {
  const i = e.product_identifier;
  if (i in n)
    return el(
      t,
      e,
      n[i]
    );
  if (i in r)
    return tl(
      t,
      e,
      r[i]
    );
  throw new Q(
    X.CustomerInfoError,
    "Could not find entitlement product in subscriptions or non-subscriptions."
  );
}
function el(t, e, n) {
  return {
    identifier: t,
    isActive: Zs(e),
    willRenew: il(e, n),
    store: (n == null ? void 0 : n.store) ?? "unknown",
    latestPurchaseDate: new Date(e.purchase_date),
    originalPurchaseDate: new Date(e.purchase_date),
    expirationDate: Me(e.expires_date),
    productIdentifier: e.product_identifier,
    unsubscribeDetectedAt: Me(
      n == null ? void 0 : n.unsubscribe_detected_at
    ),
    billingIssueDetectedAt: Me(
      n == null ? void 0 : n.billing_issues_detected_at
    ),
    isSandbox: (n == null ? void 0 : n.is_sandbox) ?? !1,
    periodType: (n == null ? void 0 : n.period_type) ?? "normal"
  };
}
function tl(t, e, n) {
  return {
    identifier: t,
    isActive: !0,
    willRenew: !1,
    store: n.store,
    latestPurchaseDate: new Date(e.purchase_date),
    originalPurchaseDate: new Date(
      n.original_purchase_date
    ),
    expirationDate: null,
    productIdentifier: e.product_identifier,
    unsubscribeDetectedAt: null,
    billingIssueDetectedAt: null,
    isSandbox: n.is_sandbox,
    periodType: "normal"
  };
}
function nl(t, e, n) {
  const r = {}, i = {};
  for (const o in t) {
    const s = Js(
      o,
      t[o],
      e,
      n
    );
    r[o] = s, s.isActive && (i[o] = s);
  }
  return {
    all: r,
    active: i
  };
}
function Me(t) {
  return t == null ? null : new Date(t);
}
function rl(t) {
  const e = sl(t), n = t.subscriber, r = al(
    n.non_subscriptions
  );
  return {
    entitlements: nl(
      n.entitlements,
      n.subscriptions,
      r
    ),
    allExpirationDatesByProduct: e,
    allPurchaseDatesByProduct: ol(
      t,
      r
    ),
    activeSubscriptions: ll(e),
    managementURL: n.management_url,
    requestDate: new Date(t.request_date),
    firstSeenDate: new Date(n.first_seen),
    originalPurchaseDate: Me(
      n.original_purchase_date
    ),
    originalAppUserId: t.subscriber.original_app_user_id
  };
}
function il(t, e) {
  if (e == null) return !1;
  const n = e.store == "promotional", r = t.expires_date == null, i = e.unsubscribe_detected_at != null, o = e.billing_issues_detected_at != null;
  return !(n || r || i || o);
}
function ol(t, e) {
  const n = {};
  for (const r in t.subscriber.subscriptions) {
    const i = t.subscriber.subscriptions[r];
    n[r] = new Date(
      i.purchase_date
    );
  }
  for (const r in e) {
    const i = e[r].purchase_date;
    i == null ? n[r] = null : n[r] = new Date(i);
  }
  return n;
}
function sl(t) {
  const e = {};
  for (const n in t.subscriber.subscriptions) {
    const r = t.subscriber.subscriptions[n];
    r.expires_date == null ? e[n] = null : e[n] = new Date(
      r.expires_date
    );
  }
  return e;
}
function ll(t) {
  const e = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Date();
  for (const r in t) {
    const i = t[r];
    (i == null || i > n) && e.add(r);
  }
  return e;
}
function al(t) {
  const e = {};
  for (const n in t) {
    if (t[n].length === 0) continue;
    const r = t[n].length;
    e[n] = t[n][r - 1];
  }
  return e;
}
const cl = "0.11.2", ul = "https://api.revenuecat.com";
var Ce;
(function(t) {
  t[t.CONTINUE = 100] = "CONTINUE", t[t.SWITCHING_PROTOCOLS = 101] = "SWITCHING_PROTOCOLS", t[t.PROCESSING = 102] = "PROCESSING", t[t.EARLY_HINTS = 103] = "EARLY_HINTS", t[t.OK = 200] = "OK", t[t.CREATED = 201] = "CREATED", t[t.ACCEPTED = 202] = "ACCEPTED", t[t.NON_AUTHORITATIVE_INFORMATION = 203] = "NON_AUTHORITATIVE_INFORMATION", t[t.NO_CONTENT = 204] = "NO_CONTENT", t[t.RESET_CONTENT = 205] = "RESET_CONTENT", t[t.PARTIAL_CONTENT = 206] = "PARTIAL_CONTENT", t[t.MULTI_STATUS = 207] = "MULTI_STATUS", t[t.MULTIPLE_CHOICES = 300] = "MULTIPLE_CHOICES", t[t.MOVED_PERMANENTLY = 301] = "MOVED_PERMANENTLY", t[t.MOVED_TEMPORARILY = 302] = "MOVED_TEMPORARILY", t[t.SEE_OTHER = 303] = "SEE_OTHER", t[t.NOT_MODIFIED = 304] = "NOT_MODIFIED", t[t.USE_PROXY = 305] = "USE_PROXY", t[t.TEMPORARY_REDIRECT = 307] = "TEMPORARY_REDIRECT", t[t.PERMANENT_REDIRECT = 308] = "PERMANENT_REDIRECT", t[t.BAD_REQUEST = 400] = "BAD_REQUEST", t[t.UNAUTHORIZED = 401] = "UNAUTHORIZED", t[t.PAYMENT_REQUIRED = 402] = "PAYMENT_REQUIRED", t[t.FORBIDDEN = 403] = "FORBIDDEN", t[t.NOT_FOUND = 404] = "NOT_FOUND", t[t.METHOD_NOT_ALLOWED = 405] = "METHOD_NOT_ALLOWED", t[t.NOT_ACCEPTABLE = 406] = "NOT_ACCEPTABLE", t[t.PROXY_AUTHENTICATION_REQUIRED = 407] = "PROXY_AUTHENTICATION_REQUIRED", t[t.REQUEST_TIMEOUT = 408] = "REQUEST_TIMEOUT", t[t.CONFLICT = 409] = "CONFLICT", t[t.GONE = 410] = "GONE", t[t.LENGTH_REQUIRED = 411] = "LENGTH_REQUIRED", t[t.PRECONDITION_FAILED = 412] = "PRECONDITION_FAILED", t[t.REQUEST_TOO_LONG = 413] = "REQUEST_TOO_LONG", t[t.REQUEST_URI_TOO_LONG = 414] = "REQUEST_URI_TOO_LONG", t[t.UNSUPPORTED_MEDIA_TYPE = 415] = "UNSUPPORTED_MEDIA_TYPE", t[t.REQUESTED_RANGE_NOT_SATISFIABLE = 416] = "REQUESTED_RANGE_NOT_SATISFIABLE", t[t.EXPECTATION_FAILED = 417] = "EXPECTATION_FAILED", t[t.IM_A_TEAPOT = 418] = "IM_A_TEAPOT", t[t.INSUFFICIENT_SPACE_ON_RESOURCE = 419] = "INSUFFICIENT_SPACE_ON_RESOURCE", t[t.METHOD_FAILURE = 420] = "METHOD_FAILURE", t[t.MISDIRECTED_REQUEST = 421] = "MISDIRECTED_REQUEST", t[t.UNPROCESSABLE_ENTITY = 422] = "UNPROCESSABLE_ENTITY", t[t.LOCKED = 423] = "LOCKED", t[t.FAILED_DEPENDENCY = 424] = "FAILED_DEPENDENCY", t[t.UPGRADE_REQUIRED = 426] = "UPGRADE_REQUIRED", t[t.PRECONDITION_REQUIRED = 428] = "PRECONDITION_REQUIRED", t[t.TOO_MANY_REQUESTS = 429] = "TOO_MANY_REQUESTS", t[t.REQUEST_HEADER_FIELDS_TOO_LARGE = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE", t[t.UNAVAILABLE_FOR_LEGAL_REASONS = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS", t[t.INTERNAL_SERVER_ERROR = 500] = "INTERNAL_SERVER_ERROR", t[t.NOT_IMPLEMENTED = 501] = "NOT_IMPLEMENTED", t[t.BAD_GATEWAY = 502] = "BAD_GATEWAY", t[t.SERVICE_UNAVAILABLE = 503] = "SERVICE_UNAVAILABLE", t[t.GATEWAY_TIMEOUT = 504] = "GATEWAY_TIMEOUT", t[t.HTTP_VERSION_NOT_SUPPORTED = 505] = "HTTP_VERSION_NOT_SUPPORTED", t[t.INSUFFICIENT_STORAGE = 507] = "INSUFFICIENT_STORAGE", t[t.NETWORK_AUTHENTICATION_REQUIRED = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})(Ce || (Ce = {}));
function Ze(t) {
  return t ? t.startsWith("rcb_sb_") : !1;
}
async function le(t, e) {
  const { apiKey: n, body: r, headers: i, httpConfig: o } = e, l = `${(o == null ? void 0 : o.proxyURL) ?? ul}${t.urlPath()}`;
  try {
    const a = await fetch(l, {
      method: t.method,
      headers: ml(n, i, o == null ? void 0 : o.additionalHeaders),
      body: dl(r)
    });
    return await fl(a, t), await a.json();
  } catch (a) {
    throw a instanceof TypeError ? new Q(
      X.NetworkError,
      ye.getPublicMessage(X.NetworkError),
      a.message
    ) : a;
  }
}
async function fl(t, e) {
  const n = t.status;
  if (n >= Ce.INTERNAL_SERVER_ERROR)
    Ye(e, n, await t.text());
  else if (n >= Ce.BAD_REQUEST) {
    const r = await t.json(), i = r ? JSON.stringify(r) : null, o = r == null ? void 0 : r.code, s = r == null ? void 0 : r.message;
    if (o != null) {
      const l = ye.convertCodeToBackendErrorCode(o);
      if (l == null)
        Ye(
          e,
          n,
          i,
          o
        );
      else
        throw Q.getForBackendError(
          l,
          s
        );
    } else
      Ye(e, n, i);
  }
}
function Ye(t, e, n, r) {
  throw new Q(
    X.UnknownBackendError,
    "Unknown backend error.",
    `Request: ${t.name}. Status code: ${e}. Body: ${n}.`,
    { backendErrorCode: r }
  );
}
function dl(t) {
  return t == null ? null : JSON.stringify(t);
}
const hn = "Authorization", bn = "Content-Type", wn = "Accept", yn = "X-Platform", En = "X-Version", In = "X-Is-Sandbox", pl = /* @__PURE__ */ new Set([
  hn,
  bn,
  wn,
  yn,
  En,
  In
]);
function ml(t, e, n) {
  let r = {
    [hn]: `Bearer ${t}`,
    [bn]: "application/json",
    [wn]: "application/json",
    [yn]: "web",
    [En]: cl,
    [In]: `${Ze(t)}`
  };
  return e && (r = { ...r, ...e }), n && (r = { ...n, ...r }), r;
}
const vn = "/v1/subscribers", je = "/rcbilling/v1";
class _l {
  constructor(e) {
    N(this, "appUserId");
    N(this, "method", "GET");
    N(this, "name", "getOfferings");
    this.appUserId = e;
  }
  urlPath() {
    const e = encodeURIComponent(this.appUserId);
    return `${vn}/${e}/offerings`;
  }
}
class gl {
  constructor() {
    N(this, "method", "POST");
    N(this, "name", "purchase");
  }
  urlPath() {
    return `${je}/purchase`;
  }
}
class hl {
  constructor(e, n, r) {
    N(this, "method", "GET");
    N(this, "name", "getProducts");
    N(this, "appUserId");
    N(this, "productIds");
    N(this, "currency");
    this.appUserId = e, this.productIds = n, this.currency = r;
  }
  urlPath() {
    const e = encodeURIComponent(this.appUserId), n = this.productIds.map(encodeURIComponent).join("&id="), r = this.currency ? `&currency=${this.currency}` : "";
    return `${je}/subscribers/${e}/products?id=${n}${r}`;
  }
}
class bl {
  constructor(e) {
    N(this, "method", "GET");
    N(this, "name", "getCustomerInfo");
    N(this, "appUserId");
    this.appUserId = e;
  }
  urlPath() {
    const e = encodeURIComponent(this.appUserId);
    return `${vn}/${e}`;
  }
}
class wl {
  constructor() {
    N(this, "method", "GET");
    N(this, "name", "getBrandingInfo");
  }
  urlPath() {
    return `${je}/branding`;
  }
}
class yl {
  constructor(e) {
    N(this, "method", "GET");
    N(this, "name", "getCheckoutStatus");
    N(this, "operationSessionId");
    this.operationSessionId = e;
  }
  urlPath() {
    return `${je}/checkout/${this.operationSessionId}`;
  }
}
const Je = {};
class El {
  constructor(e, n = Je) {
    N(this, "API_KEY");
    N(this, "httpConfig");
    this.API_KEY = e, this.httpConfig = n;
  }
  async getOfferings(e) {
    return await le(
      new _l(e),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async getCustomerInfo(e) {
    return await le(
      new bl(e),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async getProducts(e, n, r) {
    return await le(
      new hl(e, n, r),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async getBrandingInfo() {
    return await le(
      new wl(),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async postPurchase(e, n, r, i, o) {
    const s = {
      app_user_id: e,
      product_id: n,
      email: r,
      price_id: o.priceId,
      presented_offering_identifier: i.offeringIdentifier
    };
    return o.id !== "base_option" && (s.offer_id = o.id), i.targetingContext && (s.applied_targeting_rule = {
      rule_id: i.targetingContext.ruleId,
      revision: i.targetingContext.revision
    }), i.placementIdentifier && (s.presented_placement_identifier = i.placementIdentifier), await le(
      new gl(),
      {
        apiKey: this.API_KEY,
        body: s,
        httpConfig: this.httpConfig
      }
    );
  }
  async getCheckoutStatus(e) {
    return await le(
      new yl(e),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
}
function Il(t) {
  if (!/^rcb_[a-zA-Z0-9_.-]+$/.test(t))
    throw new Q(
      X.InvalidCredentialsError,
      "Invalid API key. Use your RevenueCat Billing API key."
    );
}
function vl(t) {
  if ((/* @__PURE__ */ new Set([
    "no_user",
    "null",
    "none",
    "nil",
    "(null)",
    "NaN",
    "\\x00",
    "",
    "unidentified",
    "undefined",
    "unknown"
  ])).has(t) || t.includes("/"))
    throw new Q(
      X.InvalidAppUserIdError,
      'Provided user id: "' + t + '" is not valid. See https://www.revenuecat.com/docs/customers/user-ids#tips-for-setting-app-user-ids for more information.'
    );
}
function $l(t) {
  if (t != null && t.endsWith("/"))
    throw new Q(
      X.ConfigurationError,
      "Invalid proxy URL. The proxy URL should not end with a trailing slash."
    );
}
function kl(t) {
  if (t) {
    for (const e in t)
      if (pl.has(e))
        throw new Q(
          X.ConfigurationError,
          "Invalid additional headers. Some headers are reserved for internal use."
        );
  }
}
var $n = /* @__PURE__ */ ((t) => (t.Current = "current", t))($n || {});
function Pl(t, e) {
  async function n(...r) {
    return await this.preload(), await t.call(this, ...r);
  }
  return n;
}
const kn = (t, e) => ({
  ...t,
  rcBillingProduct: {
    ...t.rcBillingProduct,
    presentedOfferingContext: {
      ...t.rcBillingProduct.presentedOfferingContext,
      placementIdentifier: e
    }
  }
}), ie = (t, e) => t == null ? null : kn(t, e), Tl = (t, e, n) => {
  const r = t.offering_ids_by_placement ?? null;
  if (r == null)
    return null;
  const i = t.fallback_offering_id ?? null;
  let o;
  if (n in r) {
    const l = r[n] ?? null;
    if (l == null)
      return null;
    o = e[l], o == null && (o = e[i]);
  } else
    o = e[i];
  if (o == null)
    return null;
  const s = Object.fromEntries(
    Object.entries(o.packagesById).map(([l, a]) => [
      l,
      kn(a, n)
    ])
  );
  return {
    ...o,
    packagesById: s,
    availablePackages: Object.values(s),
    weekly: ie(o.weekly, n),
    monthly: ie(
      o.monthly,
      n
    ),
    twoMonth: ie(
      o.twoMonth,
      n
    ),
    threeMonth: ie(
      o.threeMonth,
      n
    ),
    sixMonth: ie(
      o.sixMonth,
      n
    ),
    annual: ie(o.annual, n),
    lifetime: ie(
      o.lifetime,
      n
    )
  };
};
function Al(t, e) {
  const n = {};
  e.product_details.forEach((o) => {
    n[o.identifier] = o;
  });
  const r = {};
  t.offerings.forEach((o) => {
    const s = o.identifier === t.current_offering_id, l = wr(
      s,
      o,
      n,
      t.targeting
    );
    l != null && (r[o.identifier] = l);
  });
  const i = t.current_offering_id ? r[t.current_offering_id] ?? null : null;
  return Object.keys(r).length == 0 && j.debugLog(
    "Empty offerings. Please make sure you've configured offerings correctly in the RevenueCat dashboard and that the products are properly configured."
  ), {
    all: r,
    current: i
  };
}
var zt, ze;
zt = [Pl];
const Z = class Z {
  /** @internal */
  constructor(e, n, r = Je) {
    gt(ze, 5, this);
    /** @internal */
    N(this, "_API_KEY");
    /** @internal */
    N(this, "_appUserId");
    /** @internal */
    N(this, "_brandingInfo", null);
    /** @internal */
    N(this, "_loadingResourcesPromise", null);
    /** @internal */
    N(this, "backend");
    /** @internal */
    N(this, "purchaseOperationHelper");
    this._API_KEY = e, this._appUserId = n, Ze(e) && j.debugLog("Initializing Purchases SDK with sandbox API Key"), this.backend = new El(this._API_KEY, r), this.purchaseOperationHelper = new Br(this.backend);
  }
  /**
   * Set the log level. Logs of the given level and below will be printed
   * in the console.
   * Default is `LogLevel.Silent` so no logs will be printed in the console.
   * @param logLevel - LogLevel to set.
   */
  static setLogLevel(e) {
    j.setLogLevel(e);
  }
  /**
   * Get the singleton instance of Purchases. It's preferred to use the instance
   * obtained from the {@link Purchases.configure} method when possible.
   * @throws {@link UninitializedPurchasesError} if the instance has not been initialized yet.
   */
  static getSharedInstance() {
    if (Z.isConfigured())
      return Z.instance;
    throw new Dr();
  }
  /**
   * Returns whether the Purchases SDK is configured or not.
   */
  static isConfigured() {
    return Z.instance !== void 0;
  }
  /**
   * Configures the Purchases SDK. This should be called as soon as your app
   * has a unique user id for your user. You should only call this once, and
   * keep the returned instance around for use throughout your application.
   * @param apiKey - RevenueCat API Key. Can be obtained from the RevenueCat dashboard.
   * @param appUserId - Your unique id for identifying the user.
   * @param httpConfig - Advanced http configuration to customise the SDK usage {@link HttpConfig}.
   * @throws {@link PurchasesError} if the API key or user id are invalid.
   */
  static configure(e, n, r = Je) {
    return Z.instance !== void 0 && j.warnLog(
      "Purchases is already initialized. You normally should only configure Purchases once. Creating and returning new instance."
    ), Il(e), vl(n), $l(r.proxyURL), kl(r.additionalHeaders), Z.instance = new Z(e, n, r), Z.getSharedInstance();
  }
  /**
   * Loads and caches some optional data in the Purchases SDK.
   * Currently only fetching branding information. You can call this method
   * after configuring the SDK to speed up the first call to
   * {@link Purchases.purchase}.
   */
  async preload() {
    if (this.hasLoadedResources()) {
      j.verboseLog("Purchases resources are loaded. Skipping.");
      return;
    }
    if (this._loadingResourcesPromise !== null) {
      j.verboseLog("Purchases resources are loading. Waiting."), await this._loadingResourcesPromise;
      return;
    }
    return this._loadingResourcesPromise = this.backend.getBrandingInfo().then((e) => {
      this._brandingInfo = e;
    }).catch((e) => {
      let n = `${e}`;
      e instanceof Q && (n = `${e.message}. ${e.underlyingErrorMessage ? `Underlying error: ${e.underlyingErrorMessage}` : ""}`), j.errorLog(`Error fetching branding info: ${n}`);
    }).finally(() => {
      this._loadingResourcesPromise = null;
    }), this._loadingResourcesPromise;
  }
  hasLoadedResources() {
    return this._brandingInfo !== null;
  }
  /**
   * Fetch the configured offerings for this user. You can configure these
   * in the RevenueCat dashboard.
   * @param params - The parameters object to customise the offerings fetch. Check {@link GetOfferingsParams}
   */
  async getOfferings(e) {
    qo(e == null ? void 0 : e.currency);
    const n = this._appUserId, r = await this.backend.getOfferings(n), i = (e == null ? void 0 : e.offeringIdentifier) === $n.Current ? r.current_offering_id : e == null ? void 0 : e.offeringIdentifier;
    return i && (r.offerings = r.offerings.filter(
      (o) => o.identifier === i
    )), await this.getAllOfferings(r, n, e);
  }
  /**
   * Retrieves a specific offering by a placement identifier.
   * For more info see https://www.revenuecat.com/docs/tools/targeting
   * @param placementIdentifier - The placement identifier to retrieve the offering for.
   * @param params - The parameters object to customise the offerings fetch. Check {@link GetOfferingsParams}
   */
  async getCurrentOfferingForPlacement(e, n) {
    const r = this._appUserId, i = await this.backend.getOfferings(r), o = await this.getAllOfferings(
      i,
      r,
      n
    ), s = i.placements ?? null;
    return s == null ? null : Tl(
      s,
      o.all,
      e
    );
  }
  async getAllOfferings(e, n, r) {
    const i = e.offerings.flatMap((s) => s.packages).map((s) => s.platform_product_identifier), o = await this.backend.getProducts(
      n,
      i,
      r == null ? void 0 : r.currency
    );
    return this.logMissingProductIds(i, o.product_details), Al(e, o);
  }
  /**
   * Convenience method to check whether a user is entitled to a specific
   * entitlement. This will use {@link Purchases.getCustomerInfo} under the hood.
   * @param entitlementIdentifier - The entitlement identifier you want to check.
   * @returns Whether the user is entitled to the specified entitlement
   * @throws {@link PurchasesError} if there is an error while fetching the customer info.
   * @see {@link Purchases.getCustomerInfo}
   */
  async isEntitledTo(e) {
    const n = await this.getCustomerInfo();
    return e in n.entitlements.active;
  }
  /**
   * Method to perform a purchase for a given package. You can obtain the
   * package from {@link Purchases.getOfferings}. This method will present the purchase
   * form on your site, using the given HTML element as the mount point, if
   * provided, or as a modal if not.
   * @deprecated - please use .purchase
   * @param rcPackage - The package you want to purchase. Obtained from {@link Purchases.getOfferings}.
   * @param customerEmail - The email of the user. If undefined, RevenueCat will ask the customer for their email.
   * @param htmlTarget - The HTML element where the billing view should be added. If undefined, a new div will be created at the root of the page and appended to the body.
   * @returns a Promise for the customer info after the purchase is completed successfully.
   * @throws {@link PurchasesError} if there is an error while performing the purchase. If the {@link PurchasesError.errorCode} is {@link ErrorCode.UserCancelledError}, the user cancelled the purchase.
   */
  purchasePackage(e, n, r) {
    return this.purchase({
      rcPackage: e,
      customerEmail: n,
      htmlTarget: r
    });
  }
  purchase(e) {
    const { rcPackage: n, purchaseOption: r, htmlTarget: i, customerEmail: o } = e;
    let s = i ?? document.getElementById("rcb-ui-root");
    if (s === null) {
      const f = document.createElement("div");
      f.className = "rcb-ui-root", document.body.appendChild(f), s = f;
    }
    if (s === null)
      throw new Error(
        "Could not generate a mount point for the billing widget"
      );
    const l = s, a = !i, c = this._appUserId;
    return j.debugLog(
      `Presenting purchase form for package ${n.identifier}`
    ), new Promise((f, u) => {
      new Xs({
        target: l,
        props: {
          appUserId: c,
          rcPackage: n,
          purchaseOption: r,
          customerEmail: o,
          onFinished: async () => {
            j.debugLog("Purchase finished"), l.innerHTML = "", f({
              customerInfo: await this._getCustomerInfoForUserId(c)
            });
          },
          onClose: () => {
            l.innerHTML = "", j.debugLog("Purchase cancelled by user"), u(new Q(X.UserCancelledError));
          },
          onError: (m) => {
            l.innerHTML = "", u(Q.getForPurchasesFlowError(m));
          },
          purchases: this,
          brandingInfo: this._brandingInfo,
          purchaseOperationHelper: this.purchaseOperationHelper,
          asModal: a
        }
      });
    });
  }
  /**
   * Gets latest available {@link CustomerInfo}.
   * @returns The latest {@link CustomerInfo}.
   * @throws {@link PurchasesError} if there is an error while fetching the customer info.
   */
  async getCustomerInfo() {
    return await this._getCustomerInfoForUserId(this._appUserId);
  }
  /**
   * Gets the current app user id.
   */
  getAppUserId() {
    return this._appUserId;
  }
  /**
   * Change the current app user id. Returns the customer info for the new
   * user id.
   * @param newAppUserId - The user id to change to.
   */
  async changeUser(e) {
    return this._appUserId = e, await this.getCustomerInfo();
  }
  /** @internal */
  logMissingProductIds(e, n) {
    const r = {};
    n.forEach(
      (o) => r[o.identifier] = o
    );
    const i = [];
    e.forEach((o) => {
      r[o] === void 0 && i.push(o);
    }), i.length > 0 && j.debugLog(
      `Could not find product data for product ids:
        ${i.join()}.
        Please check that your product configuration is correct.`
    );
  }
  /**
   * @returns Whether the SDK is using a sandbox API Key.
   */
  isSandbox() {
    return Ze(this._API_KEY);
  }
  /**
   * Closes the Purchases instance. You should never have to do this normally.
   */
  close() {
    Z.instance === this ? Z.instance = void 0 : j.warnLog(
      "Trying to close a Purchases instance that is not the current instance. Ignoring."
    );
  }
  /** @internal */
  async _getCustomerInfoForUserId(e) {
    const n = await this.backend.getCustomerInfo(e);
    return rl(n);
  }
};
ze = mt(null), ht(ze, 1, "purchase", zt, Z), xe(ze, Z), /** @internal */
N(Z, "instance");
let Yt = Z;
export {
  X as ErrorCode,
  J as LogLevel,
  $n as OfferingKeyword,
  dr as PackageType,
  Pe as ProductType,
  Yt as Purchases,
  Q as PurchasesError,
  Dr as UninitializedPurchasesError
};
